/**
 * GENERATED FILE — do not edit by hand.
 * Regenerate with: python3 scripts/generate-seo-route-meta.py
 *
 * Maps a route path to the SEO metadata the page renders, so route `head()`
 * can emit it during SSR.
 */
export interface SeoRouteMeta {
  title?: string;
  description?: string;
  canonical?: string;
  ogImage?: string;
  ogImageAlt?: string;
  ogImageWidth?: number;
  ogImageHeight?: number;
  ogType?: string;
  noIndex?: boolean;
}

export const SEO_ROUTE_META: Record<string, SeoRouteMeta> = {
  "/board-of-advisors": {
    "title": "Board of Advisors — QbD Group",
    "description": "Meet QbD Group's Board of Advisors — esteemed industry leaders providing strategic counsel to strengthen our position in the life sciences industry.",
    "ogImage": "/og-assets/board/board-hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/en": {
    "title": "QbD Group — Life Sciences Consulting | 700+ Experts",
    "description": "QbD Group accelerates life sciences innovation with 700+ experts in regulatory affairs, quality assurance, clinical trials & compliance.",
    "ogImage": "/og-assets/hero-poster.jpg",
    "ogImageWidth": 1920,
    "ogImageHeight": 1088
  },
  "/en/a-complete-guide-to-computer-system-validation": {
    "title": "Complete Guide to Computer System Validation | QbD Group",
    "description": "Master CSV with this guide: GAMP® 5 categories, V-model methodology, GxP compliance, data integrity, and validation lifecycle for pharma and MedTech.",
    "ogImage": "/images/csv-guide/csv-background.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900,
    "ogType": "article"
  },
  "/en/about-qbd": {
    "title": "About QbD Group | Life Sciences Consulting Partner",
    "description": "Founded in 2011, QbD Group is a trusted partner for the life sciences and healthcare industries, with 700+ experts across 11 offices worldwide.",
    "ogImage": "/og-assets/about-team.jpg",
    "ogImageWidth": 1080,
    "ogImageHeight": 1350
  },
  "/en/about-qbd/board-of-advisors": {
    "title": "Board of Advisors — QbD Group",
    "description": "Meet QbD Group's Board of Advisors — esteemed industry leaders providing strategic counsel to strengthen our position in the life sciences industry.",
    "ogImage": "/og-assets/board/board-hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/en/about-qbd/ecosystem": {
    "title": "Ecosystem | QbD Group Partners & Companies",
    "description": "Discover QbD Group's comprehensive ecosystem of companies and strategic partners delivering expertise across the life sciences industry.",
    "ogImage": "/og-assets/about-ecosystem.png",
    "ogImageWidth": 900,
    "ogImageHeight": 600
  },
  "/en/about-qbd/projects": {
    "title": "Projects | QbD Group",
    "description": "Discover the collaborative projects and initiatives QbD Group is part of, advancing innovation across the life sciences sector.",
    "ogImage": "/og-assets/projects/atmp-xb-hero.jpg",
    "ogImageWidth": 1584,
    "ogImageHeight": 672
  },
  "/en/about-qbd/projects/atmp-xb": {
    "title": "ATMP XB | QbD Group",
    "description": "QbD Group is a partner in ATMP XB, an EU co-funded Interreg project strengthening the Flemish-Dutch border region as a hub for cell and gene therapy innovation.",
    "ogImage": "/og-assets/projects/atmp-xb-hero.jpg",
    "ogImageWidth": 1584,
    "ogImageHeight": 672
  },
  "/en/about-qbd/projects/ranger": {
    "title": "RANGER Program | QbD Group",
    "description": "QbD Group is part of the EU-funded RANGER consortium, supporting the IVDR certification of a respiratory pathogen diagnostic across software, quality, regulatory affairs and clinical services.",
    "ogImage": "/og-assets/projects/ranger-hero.png",
    "ogImageWidth": 1492,
    "ogImageHeight": 672
  },
  "/en/about-qbd/qbd-group-foundation": {
    "title": "QbD Group Foundation | Making a Difference",
    "description": "The QbD Group Foundation supports science, helps individuals facing health threats, protects the environment, and monitors social commitment across the organization.",
    "ogImage": "/og-assets/foundation-hero.jpg",
    "ogImageWidth": 1920,
    "ogImageHeight": 1080
  },
  "/en/about-qbd/story": {
    "title": "Our Story | QbD Group History & Founders",
    "description": "Discover how QbD Group was founded in 2011 by Bart Van Acker and has grown into a 700+ employee life sciences consultancy with offices worldwide.",
    "ogImage": "/og-assets/story/bart-hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 1600
  },
  "/en/about-qbd/team": {
    "title": "Our Team | QbD Group Leadership",
    "description": "Meet the leadership team behind QbD Group, over 600 expert consultants across 11 offices, led by seasoned professionals driving strategic vision in life sciences.",
    "ogImage": "/og-assets/about-team.jpg",
    "ogImageWidth": 1080,
    "ogImageHeight": 1350
  },
  "/en/annex-1-diagnostic": {
    "title": "Annex 1 Compliance Diagnostic | QbD Group",
    "description": "A practical diagnostic across the seven areas most frequently flagged in inspections. 20 questions, 7 sections, instant results.",
    "ogImage": "/__l5e/assets-v1/7a4ffa9e-a801-4371-8f3e-d3a6a3e888b4/annex-1-diagnostic-hero.png"
  },
  "/en/biotech-readiness": {
    "title": "Biotech Development Readiness Checklist | QbD Group",
    "description": "From Strategy to First-in-Human. A free readiness self-assessment for biotech teams preparing for their first clinical trial. 18 questions, instant results.",
    "ogImage": "/__l5e/assets-v1/8ef3dd89-f066-4aab-95e3-a89798759a1b/biotech-readiness-hero.png"
  },
  "/en/blog": {
    "title": "Blog — Insights & Updates | QbD Group",
    "description": "Stay informed with the latest regulatory insights, industry news, and expert perspectives from QbD Group.",
    "ogImage": "https://jrtdedcfhvzaomneervp.supabase.co/storage/v1/object/public/blog-images/ai-medical-information-pharma.png",
    "ogImageAlt": "QbD Group"
  },
  "/en/case-studies": {
    "title": "Case Studies | QbD Group",
    "description": "Real-world examples of how QbD Group helps life sciences companies navigate regulatory challenges and accelerate market launch.",
    "ogImage": "https://jrtdedcfhvzaomneervp.supabase.co/storage/v1/object/public/blog-images/case-studies%2Ftechdow-header.png"
  },
  "/en/certifications": {
    "title": "Licenses & Certifications | QbD Group",
    "description": "QbD Group holds ISO 13485, ISO 27001, EUROTOX, and GMDP certifications — ensuring compliance and product excellence across life sciences.",
    "ogImage": "/og-assets/certifications-hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/en/contact": {
    "title": "Contact Us | QbD Group",
    "description": "Get in touch with QbD Group. Find our offices worldwide and reach out to our experts for regulatory, quality, and clinical support.",
    "ogImage": "/og-assets/contact-hq.jpg",
    "ogImageWidth": 1920,
    "ogImageHeight": 1080
  },
  "/en/cookie-statement": {
    "title": "Cookie Statement | QbD Group",
    "description": "Learn how QbD Group uses cookies and similar technologies on our website.",
    "noIndex": true
  },
  "/en/cphi-milan-networking-event": {
    "title": "Getting Access to the EU Market — CPHI Milan Networking Event | QbD Group",
    "description": "An exclusive evening networking event hosted by QbD Group and Kalms Consulting on Wednesday, 7 October 2026 in Milan, during CPHI Milan 2026. Insights on regulatory, clinical and market access routes into Europe.",
    "ogImage": "/og-assets/pharma-connect/hero-networking.jpg",
    "ogImageWidth": 1672,
    "ogImageHeight": 941
  },
  "/en/downloads": {
    "title": "Downloads | QbD Group",
    "description": "In-depth technical papers, guides, and readiness assessments on regulatory strategy, quality management, and compliance across the life sciences industry.",
    "ogImage": "/__l5e/assets-v1/4f34be72-d9a2-4ee2-9772-6e532c4b16a9/whitepaper-fih-readiness.png"
  },
  "/en/eu-grants": {
    "title": "EU Grant Programs | QbD Group",
    "description": "QbD Group supports life sciences consortia across EU-funded programs. Regulatory, clinical and quality expertise across Europe, from proposal to market access.",
    "ogImage": "/og-assets/projects/eu-grants-hero.jpg",
    "ogImageWidth": 1920,
    "ogImageHeight": 1024
  },
  "/en/eu-readiness": {
    "title": "EU Readiness Assessments | QbD Group",
    "description": "Free EU readiness assessments for medical devices, pharmaceuticals, and cardiology clinical trials. Identify compliance gaps in 10–15 minutes.",
    "ogImage": "/og-assets/europe-map-bg.jpg",
    "ogImageWidth": 1920,
    "ogImageHeight": 1080
  },
  "/en/eu-readiness-cardiology": {
    "title": "EU Cardiology Trial Readiness Checklist | QbD Group",
    "description": "Free 5-minute readiness checklist for sponsors planning structural heart or coronary clinical trials in Europe. Get instant clinical and regulatory results.",
    "ogImage": "/og-assets/europe-map-bg.jpg",
    "ogImageWidth": 1920,
    "ogImageHeight": 1080
  },
  "/en/eu-readiness-medtech": {
    "title": "EU MDR Readiness Assessment for Medtech | QbD Group",
    "description": "Free 5-minute self-assessment for medical device manufacturers entering the EU. Score your MDR, quality system and clinical evidence readiness instantly.",
    "ogImage": "/og-assets/europe-map-bg.jpg",
    "ogImageWidth": 1920,
    "ogImageHeight": 1080
  },
  "/en/eu-readiness-pharma": {
    "title": "EU Pharma Market Readiness Assessment | QbD Group",
    "description": "Free 5-minute self-assessment for pharma companies entering the EU. Score your regulatory strategy, GMP and quality readiness and get instant results.",
    "ogImage": "/og-assets/europe-map-bg.jpg",
    "ogImageWidth": 1920,
    "ogImageHeight": 1080
  },
  "/en/events": {
    "title": "Events Calendar | QbD Group",
    "description": "Browse QbD Group's events calendar, conferences, summits, and industry events across the life sciences landscape.",
    "ogImage": "/og-assets/events-hero-bg.jpg",
    "ogImageWidth": 1344,
    "ogImageHeight": 768
  },
  "/en/industries": {
    "title": "Industries We Serve | QbD Group",
    "description": "QbD Group serves pharma, biotech, medical devices, IVD, CDx, combination products, and software companies with tailored regulatory solutions.",
    "ogImage": "/og-assets/industry-ivd.webp",
    "ogImageWidth": 1344,
    "ogImageHeight": 768
  },
  "/en/industries/combination-products": {
    "title": "Combination Products | QbD Group",
    "description": "Navigating EU and US regulatory pathways for combination products Navigating regulatory pathways can often feel like a maze, leading to uncertainty and…",
    "ogImage": "/og-assets/solutions/combination-products-hero.jpg",
    "ogImageWidth": 1536,
    "ogImageHeight": 864
  },
  "/en/industries/companion-diagnostics": {
    "title": "PrecisionDx (CDx) | QbD Group",
    "description": "End-to-End Companion Diagnostics and Precision Medicine Expertise We specialize in synchronizing Pharma and IVD workstreams to ensure the seamless integration…",
    "ogImage": "/og-assets/images/heroes/hero-precision-dx.webp",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/en/industries/in-vitro-diagnostics": {
    "title": "In vitro diagnostics (IVD) | QbD Group",
    "description": "The in vitro diagnostics (IVD) industry is evolving rapidly, driven by technological innovations, complex regulatory landscapes, and the increasing need fo",
    "ogImage": "/og-assets/industries/in-vitro-diagnostics/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/en/industries/medical-devices": {
    "title": "Medical devices | QbD Group",
    "description": "Are you looking for quality, regulatory or clinical support for your medical device? QbD Group can support you at any stage in the lifecycle of your medica",
    "ogImage": "/og-assets/industries/medical-devices/hero.jpg",
    "ogImageWidth": 1500,
    "ogImageHeight": 1000
  },
  "/en/industries/medical-devices/md-cro-cardiology": {
    "title": "Your CRO for Cardiology Medical Devices | QbD Group",
    "description": "As a European CRO dedicated to medical devices, we offer deep expertise in Cardiology Medical Device clinical research. From heart failure devices and sten",
    "ogImage": "/og-assets/services/clinical-solutions/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/en/industries/medical-devices/medical-device-software": {
    "title": "SaMD / Medical Device Software | QbD Group",
    "description": "Full MDSW lifecycle support Medical device software manufacturers face complex classification, evolving standards, and increasing cybersecurity demands. QbD…",
    "ogImage": "/og-assets/solutions/medical-device-software.jpg",
    "ogImageWidth": 1200,
    "ogImageHeight": 675
  },
  "/en/industries/pharma-biotech": {
    "title": "Pharma & biotech | QbD Group",
    "description": "Navigating pharma and biotech regulations demands deep expertise. QbD Group supports you from development through regulatory submission and post-market com",
    "ogImage": "/og-assets/industries/pharma-biotech/hero.jpg",
    "ogImageWidth": 1000,
    "ogImageHeight": 1500
  },
  "/en/industries/pharma-biotech/landing-in-europe/us-biotech": {
    "title": "Bring Your Biotech to Europe and the UK with Confidence | QbD Group",
    "description": "Integrated regulatory, quality, and operational expertise to turn US progress into European market readiness European expansion requires more than extending an…",
    "ogImage": "/og-assets/solutions/market-entry-eu.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/en/knowledge-center": {
    "title": "Knowledge Center | QbD Group",
    "description": "Explore expert resources on regulatory strategy, quality management, and compliance, blogs, webinars, white papers, case studies, and more."
  },
  "/en/news": {
    "title": "Company News | QbD Group",
    "description": "The latest announcements, partnerships, and milestones from QbD Group — stay informed on our growth and impact."
  },
  "/en/newsletter": {
    "title": "Newsletter | Life Sciences Insights | QbD Group",
    "description": "Subscribe to QbD Group's newsletter for expert regulatory insights, compliance guidance, and industry analysis delivered to your inbox."
  },
  "/en/podcasts": {
    "title": "Podcasts | QbD Group",
    "description": "Listen to expert discussions on regulatory strategy, clinical trials, and quality management in the life sciences industry.",
    "ogImage": "https://jrtdedcfhvzaomneervp.supabase.co/storage/v1/object/public/webinar-images/podcasts/ivds-in-clinical-trials.png"
  },
  "/en/privacy-policy": {
    "title": "Privacy Policy | QbD Group",
    "description": "QbD Group's privacy policy — how we collect, use, and protect your personal data.",
    "noIndex": true
  },
  "/en/qbdpharmaconnect": {
    "title": "QbD Pharma Connect – Leiden, 12 November 2026",
    "description": "An exclusive evening for pharma manufacturing professionals. Hosted by QbD Group & Rescop at Van der Valk Hotel Leiden on 12 November 2026.",
    "ogImage": "/og-assets/pharma-connect/hero-networking.jpg",
    "ogImageWidth": 1672,
    "ogImageHeight": 941
  },
  "/en/regulatory-updates": {
    "title": "Regulatory Updates | QbD Group",
    "description": "Stay current on regulatory changes affecting pharma, medical devices, and IVD — expert analysis of new guidelines and legislation.",
    "ogImage": "https://jrtdedcfhvzaomneervp.supabase.co/storage/v1/object/public/blog-images/regulatory-updates%2Fmdr-well-established-technologies.png"
  },
  "/en/request-your-audit": {
    "title": "Request Your Audit – Global GxP, ISO & MDR Audit Services | QbD Group",
    "description": "Request your independent audit for pharma, MedTech, or biotech. QbD Group's certified auditors perform ISO, GxP, and MDR audits worldwide. Response within 1 business day."
  },
  "/en/resources": {
    "title": "Knowledge Center | QbD Group",
    "description": "Explore expert resources on regulatory strategy, quality management, and compliance, blogs, webinars, white papers, case studies, and more."
  },
  "/en/search": {
    "title": "Search Results | QbD Group",
    "description": "Search content on QbD Group",
    "noIndex": true
  },
  "/en/services": {
    "title": "Our Services | QbD Group",
    "description": "Comprehensive life sciences services for every phase of your product journey, from development through manufacturing, launch, and post-market."
  },
  "/en/services/clinical-solutions/clinical-evidence-support": {
    "title": "Clinical Evidence Support — Clinical Solutions | QbD Group",
    "description": "We provide expert support to streamline your clinical evidence strategy and medical writing needs, ensuring that your device meets regulatory expectations",
    "ogImage": "/og-assets/services/clinical-solutions/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/en/services/clinical-solutions/clinical-expert-services": {
    "title": "Clinical Expert Services & Flexible Resourcing for Clinical Trials | QbD Group",
    "description": "Add CRAs, CTAs and clinical project managers to your clinical team across Europe. Flexible resourcing and FSP support without outsourcing your full study.",
    "ogImage": "/og-assets/services/clinical-solutions/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/en/services/clinical-solutions/clinical-pharmacovigilance-service": {
    "title": "Clinical Pharmacovigilance Service — Clinical Solutions | QbD Group",
    "description": "Pharmacovigilance is the science of detecting, assessing, and preventing adverse effects. At QbD Group, we offer full pharmacovigilance services for the sa",
    "ogImage": "/og-assets/services/clinical-solutions/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/en/services/clinical-solutions/clinical-quality-services": {
    "title": "Clinical Quality Services — Clinical Solutions | QbD Group",
    "description": "Struggling to establish or maintain your Clinical Quality Management System (QMS)? Our clinical team has auditors and QA experts who specialize in providin",
    "ogImage": "/og-assets/services/clinical-solutions/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/en/services/clinical-solutions/clinical-regulatory-services": {
    "title": "Clinical Regulatory Services — Clinical Solutions | QbD Group",
    "description": "Handling the complexities of clinical investigation approvals can be daunting. We streamline the process, ensuring you get the green light to start your st",
    "ogImage": "/og-assets/services/clinical-solutions/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/en/services/clinical-solutions/clinical-safety-management": {
    "title": "Clinical Safety Management — Clinical Solutions | QbD Group",
    "description": "Clinical Safety Management encompasses the processes and practices that ensure the safety, integrity, and ethical conduct of clinical investigations. We su",
    "ogImage": "/og-assets/services/clinical-solutions/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/en/services/clinical-solutions/clinical-strategy-support": {
    "title": "Clinical Strategy Support — Clinical Solutions | QbD Group",
    "description": "We are here to simplify the process of defining clinical strategy for your medical device, providing the expertise and guidance you need to define a robust",
    "ogImage": "/og-assets/services/clinical-solutions/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/en/services/clinical-solutions/clinical-study-operations": {
    "title": "Clinical Trial Operations — Clinical Solutions | QbD Group",
    "description": "Clinical study operations encompass the planning, execution, and management of clinical studies. At QbD Group, we focus on setting up and managing your cli",
    "ogImage": "/og-assets/services/clinical-solutions/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/en/services/clinical-solutions/data-management-and-analysis": {
    "title": "Clinical Data Management and Analysis — Clinical Solutions | QbD Group",
    "description": "Our comprehensive clinical data management services are designed to support the entire data lifecycle, from planning and CRF design to data handling, clean",
    "ogImage": "/og-assets/services/clinical-solutions/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/en/services/clinical-solutions/medical-writing-for-in-vitro-diagnostics": {
    "title": "Medical Writing for In Vitro Diagnostics — Clinical Solutions | QbD Group",
    "description": "When it comes to IVDs, having compliant clinical evidence documentation is critical. Our QbD IVD | Qarad team offers writing, consulting, and documentation",
    "ogImage": "/og-assets/services/clinical-solutions/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/en/services/clinical-solutions/medical-writing-for-medical-devices": {
    "title": "Medical Writing for Medical Devices — Clinical Solutions | QbD Group",
    "description": "High-quality medical writing is crucial for regulatory compliance and patient safety. Our team offers complete medical writing services that bridge the gap",
    "ogImage": "/og-assets/services/clinical-solutions/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/en/services/clinical-solutions/pmcf": {
    "title": "Post-Market Clinical Follow-up (PMCF) — Clinical Solutions | QbD Group",
    "description": "We help you navigate the complexities of PMCF with tailored, efficient, and MDR-compliant strategies that turn regulatory obligations into clinical and com",
    "ogImage": "/og-assets/services/clinical-solutions/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/en/services/clinical-solutions/pmpf": {
    "title": "Post-Market Performance Follow-up (PMPF) — Clinical Solutions | QbD Group",
    "description": "At QbD IVD | Qarad, we help you turn PMPF into a practical, structured process—supporting your regulatory compliance and safeguarding patient outcomes.",
    "ogImage": "/og-assets/services/clinical-solutions/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/en/services/lab-services/chemical-analysis": {
    "title": "QC Chemical Analysis — Lab Services | QbD Group",
    "description": "QbD Group's GMP-certified QC laboratory provides reliable and accurate chemical analysis services for raw materials, APIs, IMPs, and finished medicinal pro",
    "ogImage": "/og-assets/services/lab-services/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/en/services/lab-services/cleaning-validation": {
    "title": "Cleaning Validation — Lab Services | QbD Group",
    "description": "QbD Group helps you define and implement best practices for cleaning validation, ensuring compliance with industry standards and regulatory requirements.",
    "ogImage": "/og-assets/services/lab-services/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/en/services/lab-services/elemental-impurities": {
    "title": "Elemental Impurities — Lab Services | QbD Group",
    "description": "QbD Group provides expert support for analyzing, controlling, and mitigating elemental impurities in accordance with ICH Q3D guidelines.",
    "ogImage": "/og-assets/services/lab-services/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/en/services/lab-services/environmental-monitoring": {
    "title": "Environmental Monitoring — Lab Services | QbD Group",
    "description": "QbD Group specializes in environmental monitoring to help you maintain cleanroom compliance and ensure the integrity of your manufacturing processes.",
    "ogImage": "/og-assets/services/lab-services/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/en/services/lab-services/method-development": {
    "title": "Method Development — Lab Services | QbD Group",
    "description": "QbD Group combines deep scientific expertise with innovative approaches to design robust analytical methods tailored to your specific needs.",
    "ogImage": "/og-assets/services/lab-services/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/en/services/lab-services/method-validation": {
    "title": "Method Validation — Lab Services | QbD Group",
    "description": "QbD Group ensures your analytical methods align with global standards such as ICH Q2(R1) and compendial guidelines, delivering accurate, reproducible resul",
    "ogImage": "/og-assets/services/lab-services/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/en/services/lab-services/microbiological-analysis": {
    "title": "Microbiological Services — Lab Services | QbD Group",
    "description": "QbD Group provides expert microbiological testing and validation services to ensure the purity and safety of your raw materials and finished products.",
    "ogImage": "/og-assets/services/lab-services/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/en/services/lab-services/qp-release-and-eu-import": {
    "title": "QP Batch Release — Lab Services | QbD Group",
    "description": "QbD Group provides comprehensive Qualified Person (QP) batch release services, ensuring your medicinal products meet stringent EU regulatory standards.",
    "ogImage": "/og-assets/services/lab-services/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/en/services/lab-services/rd-projects": {
    "title": "R&D Projects — Lab Services | QbD Group",
    "description": "QbD Group leverages deep scientific expertise and cutting-edge technologies to support pharmaceutical R&D projects with tailored solutions.",
    "ogImage": "/og-assets/services/lab-services/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/en/services/lab-services/residual-solvent-testing-gc": {
    "title": "Residual Solvent Testing (GC) — Lab Services | QbD Group",
    "description": "Residual solvent testing identifies and quantifies trace organic solvents after manufacturing using validated GC-FID and GC-MS methods, ensuring compliance",
    "ogImage": "/og-assets/services/lab-services/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/en/services/lab-services/stability-studies": {
    "title": "Stability Studies — Lab Services | QbD Group",
    "description": "QbD Group ensures your products meet the highest quality standards through rigorous ICH-compliant stability studies with state-of-the-art facilities.",
    "ogImage": "/og-assets/services/lab-services/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/en/services/pharmacovigilance/aggregate-safety-reporting": {
    "title": "Safety Reporting & Signal Detection — Pharmacovigilance | QbD Group",
    "description": "Safety reporting is a critical component of pharmacovigilance and post-marketing surveillance. At QbD Group, we analyze and deliver safety reports that ens",
    "ogImage": "/og-assets/services/pharmacovigilance/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/en/services/pharmacovigilance/comprehensive-medical-information-services": {
    "title": "Medical Information Services — Pharmacovigilance | QbD Group",
    "description": "Accurate, timely medical information is more than a regulatory requirement — it is a core pillar of patient safety and product trust. QbD Group combines ex",
    "ogImage": "/og-assets/services/pharmacovigilance/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/en/services/pharmacovigilance/eudravigilance-services": {
    "title": "EudraVigilance Medicinal Product Dictionary (XEVMPD) — Pharmacovigilance | QbD Group",
    "description": "Achieve XEVMPD compliance effortlessly with QbD's expertise. Simplify your regulatory submissions and maintain up-to-date safety profiles with comprehensiv",
    "ogImage": "/og-assets/services/pharmacovigilance/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/en/services/pharmacovigilance/icsr-management": {
    "title": "ICSRs Management — Pharmacovigilance | QbD Group",
    "description": "Managing safety case reports effectively is a cornerstone of pharmacovigilance and clinical trial oversight. At QbD Group, our specialized ICSRs Management",
    "ogImage": "/og-assets/services/pharmacovigilance/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/en/services/pharmacovigilance/literature-monitoring": {
    "title": "Literature Monitoring Search Solutions & Alerts — Pharmacovigilance | QbD Group",
    "description": "Stay compliant with QbD Group's Literature Monitoring Services. Detect safety signals, ensure timely reporting, and enhance your vigilance strategy with sy",
    "ogImage": "/og-assets/services/pharmacovigilance/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/en/services/pharmacovigilance/pharmacovigilance-certified-blended-training": {
    "title": "Pharmacovigilance & Certified Blended Training — Pharmacovigilance | QbD Group",
    "description": "In the fast-evolving world of pharmacovigilance, ensuring your team is well-trained and compliant with national and international regulations is critical.",
    "ogImage": "/og-assets/services/pharmacovigilance/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/en/services/pharmacovigilance/project-management": {
    "title": "Project Management — Pharmacovigilance | QbD Group",
    "description": "Coordinate pharmacovigilance projects seamlessly with QbD's project management expertise. Drive safety goals, meet compliance requirements, and improve ope",
    "ogImage": "/og-assets/services/pharmacovigilance/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/en/services/pharmacovigilance/pv-audits-inspections-quality-system-management": {
    "title": "Pharmacovigilance (PV) Audits — Pharmacovigilance | QbD Group",
    "description": "At QbD Group, we provide certified PV audits, mock inspections, and ISO-related activities to ensure your pharmacovigilance system adheres to Good Pharmaco",
    "ogImage": "/og-assets/services/pharmacovigilance/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/en/services/pharmacovigilance/qms-psmf-services": {
    "title": "Pharmacovigilance QMS & PSMF Services — Pharmacovigilance | QbD Group",
    "description": "Ensuring compliance with national and international pharmacovigilance regulations requires robust systems and meticulous documentation. At QbD Group, we of",
    "ogImage": "/og-assets/services/pharmacovigilance/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/en/services/pharmacovigilance/qppv-local-representative": {
    "title": "Local QPPV Representative Services — Pharmacovigilance | QbD Group",
    "description": "Managing pharmacovigilance responsibilities across multiple regions can be complex. At QbD Vigilance, we provide QPPV and Local Representative services tai",
    "ogImage": "/og-assets/services/pharmacovigilance/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/en/services/pharmacovigilance/regulatory-intelligence": {
    "title": "Regulatory Intelligence — Pharmacovigilance | QbD Group",
    "description": "In today's fast-evolving regulatory landscape, staying compliant with international and local legislation is essential. At QbD Group, our Regulatory Intell",
    "ogImage": "/og-assets/services/pharmacovigilance/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/en/services/pharmacovigilance/safety-database-solution": {
    "title": "Tracking Adverse Drug Reactions — Pharmacovigilance | QbD Group",
    "description": "Monitor and address adverse drug reactions with precision. QbD Group's safety database solutions support regulatory compliance while prioritizing operation",
    "ogImage": "/og-assets/services/pharmacovigilance/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/en/services/pharmacovigilance/signal-detection-management": {
    "title": "Safety Signal Program — Pharmacovigilance | QbD Group",
    "description": "Enhance patient safety with QbD Group's Safety Signal Program. Detect risks early, ensure compliance, and build trust with proactive safety solutions throu",
    "ogImage": "/og-assets/services/pharmacovigilance/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/en/services/pharmacovigilance/vigilance-pharmacovigilance-hotline-services": {
    "title": "Vigilance and Pharmacovigilance Hotline Services — Pharmacovigilance | QbD Group",
    "description": "Emergencies don't sleep and neither does our support. The One Vigilance hotline is open 24/7 all year round, providing dedicated pharmacovigilance support",
    "ogImage": "/og-assets/services/pharmacovigilance/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/en/services/qualification-validation/analytical-method-validation": {
    "title": "Analytical Method Validation — Qualification & Validation | QbD Group",
    "description": "Ensure your pharmaceutical products meet the highest regulatory standards with our comprehensive analytical method validation services. We specialize in pr",
    "ogImage": "/og-assets/services/qualification-validation/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/en/services/qualification-validation/cleaning-validation": {
    "title": "Cleaning Validation — Qualification & Validation | QbD Group",
    "description": "QbD offers a wide range of qualification and validation services for your processes, applications, and equipment. Our experts have in-depth knowledge of cl",
    "ogImage": "/og-assets/services/qualification-validation/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/en/services/qualification-validation/commissioning": {
    "title": "Commissioning — Qualification & Validation | QbD Group",
    "description": "Commissioning is crucial for getting your systems and equipment to perform at their best and be safe across industries. At QbD Group we are experts in maki",
    "ogImage": "/og-assets/services/qualification-validation/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/en/services/qualification-validation/equipment-qualification": {
    "title": "Equipment Qualification — Qualification & Validation | QbD Group",
    "description": "Are you looking for a turnkey solution for the C&Q and Equipment Qualification part of your project? Whether you are building or renovating and need to qua",
    "ogImage": "/og-assets/services/qualification-validation/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/en/services/qualification-validation/facility-qualification": {
    "title": "Facility Qualification — Qualification & Validation | QbD Group",
    "description": "At QbD Group, we offer facility qualification services tailored to your specific industry and regulatory requirements. By partnering with us, you can trust",
    "ogImage": "/og-assets/services/qualification-validation/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/en/services/qualification-validation/process-product-support": {
    "title": "Process & Product Support — Qualification & Validation | QbD Group",
    "description": "Our experienced team offers expertise in process optimization, quality management, regulatory compliance, and continuous improvement methodologies to help",
    "ogImage": "/og-assets/services/qualification-validation/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/en/services/qualification-validation/process-validation": {
    "title": "Process Validation — Qualification & Validation | QbD Group",
    "description": "Are you looking for expertise in process validation? Process Validation is a critical component of maintaining product quality, regulatory compliance, and",
    "ogImage": "/og-assets/services/qualification-validation/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/en/services/qualification-validation/sterilization-validation": {
    "title": "Sterilization Validation — Qualification & Validation | QbD Group",
    "description": "We specialize in comprehensive sterilization validation services tailored to your specific industry and regulatory requirements. Sterilization Validation i",
    "ogImage": "/og-assets/services/qualification-validation/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/en/services/qualification-validation/tech-transfer": {
    "title": "Tech Transfer — Qualification & Validation | QbD Group",
    "description": "Tech transfer is a vital process in translating innovation into real-world applications, driving economic growth, and fostering collaboration and innovatio",
    "ogImage": "/og-assets/services/qualification-validation/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/en/services/qualification-validation/utility-qualification": {
    "title": "Utility Qualification — Qualification & Validation | QbD Group",
    "description": "At QbD Group, we offer utility qualification services tailored to your specific industry and regulatory requirements. Partner with QbD Group to ensure your",
    "ogImage": "/og-assets/services/qualification-validation/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/en/services/quality-assurance/qa-consultancy-apr-pqr": {
    "title": "Annual Product Review (APR) & Product Quality Review (PQR) — Quality Assurance | QbD Group",
    "description": "QbD Group offers full support for Annual Product Review and Product Quality Review — from data analysis and PQR writing to compliance review. These mandato",
    "ogImage": "/og-assets/services/quality-assurance/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/en/services/quality-assurance/integrated-audit-solutions": {
    "title": "QA Audits & Remediation — Quality Assurance | QbD Group",
    "description": "QbD Group offers certified and experienced auditors to perform internal and supplier audits on your behalf. Our QA experts can also support you in resolvin",
    "ogImage": "/og-assets/services/quality-assurance/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/en/services/quality-assurance/regulatory-inspection-readiness": {
    "title": "Quality Assurance (QA) Services | QbD Group",
    "description": "Streamline your quality management with our comprehensive QA services for pharma and medical devices. From tackling compliance challenges to ensuring top-n",
    "ogImage": "/og-assets/services/quality-assurance/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/en/services/quality-assurance/qa-support-outsourcing": {
    "title": "QA Outsourcing — Quality Assurance | QbD Group",
    "description": "At QbD Group, we take over your quality assurance activities with a dedicated team of experts. From supplier management to deviation handling, we provide s",
    "ogImage": "/og-assets/services/quality-assurance/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/en/services/quality-assurance/qms-remediation-support": {
    "title": "QMS Remediation & Support — Quality Assurance | QbD Group",
    "description": "QbD Group offers QA experts experienced in managing and upgrading Quality Management Systems to ensure continuous compliance and operational excellence. Fr",
    "ogImage": "/og-assets/services/quality-assurance/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/en/services/quality-assurance/qms-development-optimization": {
    "title": "QMS Implementation — Quality Assurance | QbD Group",
    "description": "At QbD Group, we provide QA experts experienced in creating smart, effective, and compliant QMS solutions tailored to your needs. Whether your focus is GMP",
    "ogImage": "/og-assets/services/quality-assurance/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/en/services/quality-assurance/qmsr-compliance": {
    "title": "QMSR Compliance Services — Quality Assurance | QbD Group",
    "description": "The FDA's Quality Management System Regulation (QMSR) replaced 21 CFR Part 820 and now incorporates ISO 13485:2016 by reference, with FDA-specific requirem",
    "ogImage": "/og-assets/services/quality-assurance/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/en/services/quality-assurance/qp-rp-prrc-services": {
    "title": "Qualified Person (QP) & Responsible Person (RP) Services — Quality Assurance | QbD Group",
    "description": "QbD Group provides experienced Qualified Persons and Responsible Persons to help you meet mandatory requirements, maintain compliance, and ensure operation",
    "ogImage": "/og-assets/services/quality-assurance/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/en/services/regulatory-affairs-services-for-ivd": {
    "title": "Regulatory Affairs for In Vitro Diagnostics | QbD Group",
    "description": "Ensure your in vitro diagnostic products meet evolving regulatory standards worldwide. Our experts support you in building robust, compliant files that sta",
    "ogImage": "/og-assets/services/regulatory-affairs/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/en/services/regulatory-affairs-services-for-medical-devices": {
    "title": "Regulatory Affairs for Medical Devices | QbD Group",
    "description": "Bring safe, compliant medical devices to market faster with strategic regulatory support tailored to your technology. From classification to submission, we",
    "ogImage": "/og-assets/services/regulatory-affairs/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/en/services/regulatory-affairs-services-for-pharma-biotech": {
    "title": "Regulatory Affairs for Pharma & Biotech | QbD Group",
    "description": "Navigate complex global regulations with confidence through expert guidance across the full product lifecycle. We help you accelerate approvals and maintai",
    "ogImage": "/og-assets/services/regulatory-affairs/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/en/services/regulatory-affairs/artwork-labeling": {
    "title": "Artwork & Labeling — Regulatory Affairs | QbD Group",
    "description": "Directive 2001/83/EC requires that label texts must be in accordance with the approved Summary of Product Characteristics. QbD Group helps you create pharm",
    "ogImage": "/og-assets/services/regulatory-affairs/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/en/services/regulatory-affairs/authorized-representative-eu-rep": {
    "title": "Authorized Representative (EU-REP) — Regulatory Affairs | QbD Group",
    "description": "If you're a medical device or IVD manufacturer outside the EU/EEA, appointing an EU-based Authorized Representative is a legal requirement to ensure compli",
    "ogImage": "/og-assets/services/regulatory-affairs/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/en/services/regulatory-affairs/coaching-training": {
    "title": "Coaching & Training — Regulatory Affairs | QbD Group",
    "description": "QbD Group offers tailored training programs designed to build practical regulatory competence for medical device and IVD teams, from MDR/IVDR fundamentals",
    "ogImage": "/images/offerings/coaching-training-ra.jpg",
    "ogImageWidth": 1408,
    "ogImageHeight": 768
  },
  "/en/services/regulatory-affairs/design-and-development": {
    "title": "Design & Development — Regulatory Affairs | QbD Group",
    "description": "The design and development process is a core element of bringing safe and effective medical devices and IVDs to market. Our team provides expert guidance t",
    "ogImage": "/og-assets/services/regulatory-affairs/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/en/services/regulatory-affairs/drug-development": {
    "title": "Drug Development — Regulatory Affairs | QbD Group",
    "description": "Drug development entails drug discovery, pre-clinical and clinical testing. New chemical entities need to show minimum standards of safety, toxicity, pharm",
    "ogImage": "/og-assets/services/regulatory-affairs/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/en/services/regulatory-affairs/early-development": {
    "title": "Early Development — Regulatory Affairs | QbD Group",
    "description": "An essential step in the early stages of developing a potential medicinal product is the preparation of the Clinical Trial Application for the First in Hum",
    "ogImage": "/og-assets/services/regulatory-affairs/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/en/services/regulatory-affairs/ectd-publishing": {
    "title": "eCTD Publishing — Regulatory Affairs | QbD Group",
    "description": "Based on the content of the Common Technical Document format, the Electronic Common Technical Document transfers regulatory information from industry to ag",
    "ogImage": "/og-assets/services/regulatory-affairs/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/en/services/regulatory-affairs/in-country-representative-services": {
    "title": "In-Country Representative Services — Regulatory Affairs | QbD Group",
    "description": "Our regulatory experts serve as EU-REP/UKRP/CH-REP to allow easy access of IVD and MD devices to the European, UK, and Swiss markets.",
    "ogImage": "/og-assets/services/regulatory-affairs/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/en/services/regulatory-affairs/information-officer": {
    "title": "Information Officer — Regulatory Affairs | QbD Group",
    "description": "To be fully compliant with legal requirements, a qualified expert has to take responsibility over how information on pharmaceuticals is communicated and ma",
    "ogImage": "/og-assets/services/regulatory-affairs/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/en/services/regulatory-affairs/ivdr-compliance-ce-certification": {
    "title": "IVDR Compliance & CE Certification — Regulatory Affairs | QbD Group",
    "description": "The EU In Vitro Diagnostic Regulation (EU) 2017/746 has fundamentally changed how in vitro diagnostics access the European market. QbD Group supports manuf",
    "ogImage": "/images/offerings/ivdr-compliance-ce-certification-ra.jpg",
    "ogImageWidth": 1408,
    "ogImageHeight": 768
  },
  "/en/services/regulatory-affairs/ivdr-transition-support": {
    "title": "IVDR Transition Support — Regulatory Affairs | QbD Group",
    "description": "With average certification timelines ranging from 13–18 months and transition deadlines fast approaching, IVD manufacturers can't afford to wait. Planning",
    "ogImage": "/og-assets/services/regulatory-affairs/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/en/services/regulatory-affairs/legal-representative": {
    "title": "Legal Representative — Regulatory Affairs | QbD Group",
    "description": "For sponsors of performance studies based outside the European Union, appointing a legal representative within the Union is a regulatory requirement. QbD G",
    "ogImage": "/og-assets/services/regulatory-affairs/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/en/services/regulatory-affairs/liaison-with-notified-bodies": {
    "title": "Liaison with Notified Bodies — Regulatory Affairs | QbD Group",
    "description": "Engaging with a Notified Body is a key step in the conformity assessment process for medical devices and in vitro diagnostics. QbD Group supports manufactu",
    "ogImage": "/images/offerings/liaison-notified-bodies-ra.jpg",
    "ogImageWidth": 1408,
    "ogImageHeight": 768
  },
  "/en/services/regulatory-affairs/lifecycle-management": {
    "title": "Lifecycle Management — Regulatory Affairs | QbD Group",
    "description": "Products that have been put on the market change over time and this process must be managed. QbD Group's experts accompany you throughout the whole lifecyc",
    "ogImage": "/og-assets/services/regulatory-affairs/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/en/services/regulatory-affairs/linguistic-review": {
    "title": "Linguistic Review — Regulatory Affairs | QbD Group",
    "description": "One of the biggest challenges in the linguistic review process is the extremely short turnaround time for translations. QbD Group ensures high-quality tran",
    "ogImage": "/og-assets/services/regulatory-affairs/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/en/services/regulatory-affairs/materiovigilance": {
    "title": "Vigilance — Regulatory Affairs | QbD Group",
    "description": "Vigilance refers to the systematic monitoring, evaluation, and reporting of incidents related to medical devices and in vitro diagnostics after they are pl",
    "ogImage": "/images/offerings/materiovigilance-ra.jpg",
    "ogImageWidth": 1408,
    "ogImageHeight": 768
  },
  "/en/services/regulatory-affairs/mdr-compliance-ce-certification-for-medical-devices": {
    "title": "MDR Compliance & CE Certification — Regulatory Affairs | QbD Group",
    "description": "The European Medical Device Regulation sets a higher bar for safety, quality, and transparency. Whether you are bringing a new device to market or transiti",
    "ogImage": "/og-assets/services/regulatory-affairs/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/en/services/regulatory-affairs/mdr-transition-support": {
    "title": "MDR Transition Support — Regulatory Affairs | QbD Group",
    "description": "The shift from the MDD to the MDR is one of the most significant regulatory changes the medical device industry has faced in decades. QbD Group helps you n",
    "ogImage": "/og-assets/services/regulatory-affairs/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/en/services/regulatory-affairs/notified-body-submissions": {
    "title": "Notified Body Submissions — Regulatory Affairs | QbD Group",
    "description": "Navigating the submission process to a notified body is an essential step in obtaining CE marking for medical devices and in-vitro diagnostics. We offer co",
    "ogImage": "/og-assets/services/regulatory-affairs/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/en/services/regulatory-affairs/orphan-diseases": {
    "title": "Orphan Diseases — Regulatory Affairs | QbD Group",
    "description": "Orphan diseases are conditions that affect a small percentage of the population. QbD Group can support you in the development of medicines for patients suf",
    "ogImage": "/og-assets/services/regulatory-affairs/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/en/services/regulatory-affairs/person-responsible-for-regulatory-compliance": {
    "title": "Person Responsible for Regulatory Compliance (PRRC) — Regulatory Affairs | QbD Group",
    "description": "To sell products in the EU market, manufacturers of medical devices and IVDs must officially designate a PRRC. Without an officially designated PRRC, compa",
    "ogImage": "/og-assets/services/regulatory-affairs/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/en/services/regulatory-affairs/post-market-surveillance": {
    "title": "Post-Market Surveillance — Regulatory Affairs | QbD Group",
    "description": "Post-Market Surveillance is an essential requirement for ensuring the ongoing safety and efficacy of your IVD or medical device once it reaches the market.",
    "ogImage": "/og-assets/services/regulatory-affairs/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/en/services/regulatory-affairs/regulatory-intelligence": {
    "title": "Regulatory Intelligence — Regulatory Affairs | QbD Group",
    "description": "Regulatory intelligence is essential for successful product development and regulatory strategy. By leveraging up-to-date and comprehensive information, yo",
    "ogImage": "/og-assets/services/regulatory-affairs/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/en/services/regulatory-affairs/regulatory-procedures": {
    "title": "Regulatory Procedures — Regulatory Affairs | QbD Group",
    "description": "There are various procedures available to register pharmaceutical drugs in the EU and UK. The method chosen depends on the type of drug and the intended ro",
    "ogImage": "/og-assets/services/regulatory-affairs/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/en/services/regulatory-affairs/regulatory-strategy-md-ivd": {
    "title": "Regulatory Strategy for MD & IVD — Regulatory Affairs | QbD Group",
    "description": "A regulatory strategy is an essential framework that delineates the necessary steps and actions to effectively address the regulatory requirements for intr",
    "ogImage": "/og-assets/services/regulatory-affairs/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/en/services/regulatory-affairs/regulatory-strategy-pharma": {
    "title": "Regulatory Strategy for Pharma — Regulatory Affairs | QbD Group",
    "description": "Establishing a regulatory strategy involves choosing the right procedure for a product type, scanning local regulations and requirements, choosing in which",
    "ogImage": "/og-assets/services/regulatory-affairs/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/en/services/regulatory-affairs/scientific-advice": {
    "title": "Scientific Advice — Regulatory Affairs | QbD Group",
    "description": "Scientific advice procedures play a central role in the drug approval process. Our experienced consultants help you interact with all relevant health autho",
    "ogImage": "/og-assets/services/regulatory-affairs/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/en/services/regulatory-affairs/submissions": {
    "title": "Submissions — Regulatory Affairs | QbD Group",
    "description": "Navigating the regulatory landscape for marketing authorization can be complex, with strict requirements for documentation and compliance. We ensure your a",
    "ogImage": "/og-assets/services/regulatory-affairs/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/en/services/regulatory-affairs/swiss-authorized-representative": {
    "title": "Swiss Authorized Representative (CH-REP) — Regulatory Affairs | QbD Group",
    "description": "Manufacturers based outside Switzerland must appoint a Swiss Authorized Representative to place medical devices and IVDs on the Swiss market.",
    "ogImage": "/og-assets/services/regulatory-affairs/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/en/services/regulatory-affairs/technical-documentation": {
    "title": "Technical Documentation — Regulatory Affairs | QbD Group",
    "description": "The new regulations for IVDs and medical devices introduce more stringent requirements for technical documentation and clinical evidence. With over two dec",
    "ogImage": "/og-assets/services/regulatory-affairs/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/en/services/regulatory-affairs/ukrp-uk-responsible-person": {
    "title": "UK Responsible Person (UKRP) — Regulatory Affairs | QbD Group",
    "description": "Following Brexit, manufacturers located outside the UK must appoint a UK Responsible Person to place medical devices and IVDs on the Great Britain market.",
    "ogImage": "/og-assets/services/regulatory-affairs/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/en/services/regulatory-toxicology": {
    "title": "Regulatory Toxicology | QbD Group",
    "description": "QbD Group offers a set of pharmaceutical toxicology services, for your processes, applications, and equipment. We are EUROTOX certified and are members of",
    "ogImage": "/og-assets/hubs/services-toxicology.jpg",
    "ogImageWidth": 1200,
    "ogImageHeight": 630
  },
  "/en/services/regulatory-toxicology/biocompatibility-biological-evaluation": {
    "title": "Biocompatibility & Biological Evaluation Solutions | QbD Group",
    "description": "QbD Group supports medical device manufacturers with end-to-end biocompatibility and biological evaluation under ISO 10993, from feasibility to submission-ready BER."
  },
  "/en/services/regulatory-toxicology/elemental-impurities-reports": {
    "title": "Elemental Impurities Reports — Regulatory Toxicology | QbD Group",
    "description": "QbD Group provides comprehensive risk assessments and reports for elemental impurities in human and veterinary pharmaceutical products, ensuring compliance"
  },
  "/en/services/regulatory-toxicology/environmental-risk-assessment-era": {
    "title": "Environmental Risk Assessment (ERA) — Regulatory Toxicology | QbD Group",
    "description": "QbD Group supports pharmaceutical companies throughout the full ERA lifecycle, combining scientific expertise with a practical, risk-based approach to deli"
  },
  "/en/services/regulatory-toxicology/extractables-leachables-reports": {
    "title": "Extractables & Leachables Reports — Regulatory Toxicology | QbD Group",
    "description": "QbD Group provides toxicological assessments and risk evaluations for extractable and leachable impurities, designed to fit your specific needs and ensure"
  },
  "/en/services/regulatory-toxicology/monitoring-studies": {
    "title": "Monitoring Studies — Regulatory Toxicology | QbD Group",
    "description": "QbD Group provides expert support for follow-up of laboratory studies required in the manufacture and quality of medicines, including method validation, re"
  },
  "/en/services/regulatory-toxicology/nitrosamine-risk-assessment": {
    "title": "Nitrosamine Risk Assessment — Regulatory Toxicology | QbD Group",
    "description": "QbD Group specializes in nitrosamine risk assessments, helping pharmaceutical companies identify risks, write reports, calculate acceptable limits, and add"
  },
  "/en/services/regulatory-toxicology/organic-impurities-reports": {
    "title": "Organic Impurities Reports — Regulatory Toxicology | QbD Group",
    "description": "QbD Group offers the largest online library of high-quality toxicology reports certified by AETOX members, covering risk assessments and toxicological eval"
  },
  "/en/services/regulatory-toxicology/pde-oel-reports": {
    "title": "PDE-OEL Reports — Regulatory Toxicology | QbD Group",
    "description": "QbD Group prepares PDE/ADE reports for any Active Pharmaceutical Ingredient in compliance with EMA directives. Our ERT-certified toxicologists deliver scie"
  },
  "/en/services/regulatory-toxicology/reach-registration-compliance-support": {
    "title": "REACH Registration & Compliance — Regulatory Toxicology | QbD Group",
    "description": "QbD Group helps you navigate every step of REACH registration, from substance characterization and IUCLID dossier build to SDS authoring and Chemical Safet"
  },
  "/en/services/regulatory-toxicology/residual-solvents-reports": {
    "title": "Residual Solvents Reports — Regulatory Toxicology | QbD Group",
    "description": "QbD Group specializes in risk assessments for residual solvents in human and veterinary drug products, helping identify risks, generate comprehensive repor"
  },
  "/en/services/software-solutions-services/ai-ml-compliance": {
    "title": "AI/ML Compliance — Software Solutions & Services | QbD Group",
    "description": "In the rapidly evolving world of AI and machine learning, developing software solutions that meet regulatory standards is crucial. QbD Group offers compreh",
    "ogImage": "/og-assets/services/software-solutions-services/ai-ml-compliance.jpg",
    "ogImageWidth": 1344,
    "ogImageHeight": 768
  },
  "/en/services/software-solutions-services/data-governance": {
    "title": "Data Governance — Software Solutions & Services | QbD Group",
    "description": "Are you concerned about keeping up with complex and ever-changing data regulations? QbD Group offers data governance support helping you be compliant with",
    "ogImage": "/og-assets/services/software-solutions-services/data-governance.jpg",
    "ogImageWidth": 1344,
    "ogImageHeight": 768
  },
  "/en/services/software-solutions-services/data-integrity": {
    "title": "Data Integrity — Software Solutions & Services | QbD Group",
    "description": "Data integrity is as critical as ever, from equipment and laboratory systems to automated systems and IT infrastructure. QbD Group offers customized expert",
    "ogImage": "/og-assets/services/software-solutions-services/data-integrity.jpg",
    "ogImageWidth": 1344,
    "ogImageHeight": 768
  },
  "/en/services/software-solutions-services/digitalization": {
    "title": "Digitalization in Life Sciences — Software Solutions & Services | QbD Group",
    "description": "QbD Group helps life science companies modernize and streamline their operations. Our tailored digitalization solutions ensure a smooth transition to more",
    "ogImage": "/og-assets/services/software-solutions-services/digitalization-what.png",
    "ogImageWidth": 1200,
    "ogImageHeight": 675
  },
  "/en/services/software-solutions-services/digitalization-AI": {
    "title": "Software Solutions for Pharma & MedTech | QbD Group",
    "description": "Don't be late to the digital transformation of the life sciences industry. QbD Group leverages deep expertise in business processes, regulatory requirement",
    "ogImage": "/og-assets/services/software-solutions-services/hero.jpg",
    "ogImageWidth": 1536,
    "ogImageHeight": 864
  },
  "/en/services/software-solutions-services/ifucare": {
    "title": "IFUcare — Electronic IFU Solution — Software Solutions & Services | QbD Group",
    "description": "IFUcare offers a seamless electronic IFU service for medical device and IVD manufacturers, empowering you to leave paper IFUs behind and transition to comp",
    "ogImage": "/og-assets/services/software-solutions-services/ifucare-mockup.jpg",
    "ogImageWidth": 1000,
    "ogImageHeight": 600
  },
  "/en/services/software-solutions-services/it-infrastructure-qualification": {
    "title": "IT Infrastructure Qualification — Software Solutions & Services | QbD Group",
    "description": "In today's highly regulated environment, ensuring the reliability and compliance of IT infrastructure is a growing challenge. QbD Group offers IT infrastru",
    "ogImage": "/og-assets/services/software-solutions-services/it-infrastructure-qualification.jpg",
    "ogImageWidth": 1344,
    "ogImageHeight": 768
  },
  "/en/services/software-solutions-services/medical-device-software-compliance": {
    "title": "Medical Device Software Compliance — Software Solutions & Services | QbD Group",
    "description": "Our Medical Device Software Compliance service helps medical device and IVD companies ensure their software aligns with MDR, IVDR, FDA, ISO 13485, ISO 1497",
    "ogImage": "/og-assets/services/software-solutions-services/medical-device-software-compliance.png",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/en/services/software-solutions-services/operational-software-compliance": {
    "title": "Operational Software Compliance — Software Solutions & Services | QbD Group",
    "description": "Maintaining compliance with regulatory standards is no small task. QbD Group's operational software compliance services ensure your software systems meet i",
    "ogImage": "/og-assets/services/software-solutions-services/operational-software-compliance.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/en/services/software-solutions-services/paperless-validation": {
    "title": "Paperless Validation — Software Solutions & Services | QbD Group",
    "description": "Paperless validation offers a digital approach that revolutionizes the validation process in regulated industries. Say goodbye to paper-based documentation",
    "ogImage": "/og-assets/services/software-solutions-services/paperless-validation.jpg",
    "ogImageWidth": 1344,
    "ogImageHeight": 768
  },
  "/en/services/software-solutions-services/scilife": {
    "title": "Scilife™ — Quality Management Software — Software Solutions & Services | QbD Group",
    "description": "Scilife™ is a user-friendly, all-in-one Quality Management Software designed to streamline every aspect of your workflow — from document control and traini",
    "ogImage": "/og-assets/services/software-solutions-services/scilife-mockup.png",
    "ogImageWidth": 1280,
    "ogImageHeight": 720
  },
  "/en/services/software-solutions-services/software-implementations": {
    "title": "Software Implementations — Software Solutions & Services | QbD Group",
    "description": "Software implementations are essential for modern life science organizations to stay competitive. Our team of software experts ensures that your implementa",
    "ogImage": "/og-assets/services/software-solutions-services/software-implementations.png",
    "ogImageWidth": 600,
    "ogImageHeight": 400
  },
  "/en/services/software-solutions-services/software-validation": {
    "title": "Software Validation & Central IT Systems — Software Solutions & Services | QbD Group",
    "description": "Software validation remains as critical as ever, from automation and digitization to artificial intelligence and machine learning. QbD Group offers softwar",
    "ogImage": "/og-assets/services/software-solutions-services/software-validation.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/en/services/software-solutions-services/vlmcare": {
    "title": "VLMcare — Data-driven Validation Platform | QbD Group",
    "description": "VLMcare unifies validation lifecycle management, workflow orchestration, and audit readiness in a single platform built for GxP-regulated environments.",
    "ogImage": "/__l5e/assets-v1/9a4347e6-496b-44bc-8198-4d70a1473ce7/vlmcare-article-header.png"
  },
  "/en/share/getting-to-regatta-beach": {
    "title": "Getting to Regatta Beach — 6 June 2026 | QbD Group",
    "noIndex": true
  },
  "/en/solutions": {
    "title": "Life Sciences Solutions | QbD Group",
    "description": "Regulatory, quality, and market-launch solutions for Pharma, Biotech, Medical Devices & IVD, from idea to market readiness across Europe and beyond."
  },
  "/en/subscribe": {
    "title": "Newsletter | Life Sciences Insights | QbD Group",
    "description": "Subscribe to QbD Group's newsletter for expert regulatory insights, compliance guidance, and industry analysis delivered to your inbox."
  },
  "/en/supplier-code-of-conduct": {
    "title": "Supplier Code of Conduct | QbD Group",
    "description": "QbD Group's Supplier Code of Conduct — our expectations for ethical, sustainable, and responsible business practices.",
    "noIndex": true
  },
  "/en/terms-and-conditions": {
    "title": "Terms & Conditions | QbD Group",
    "description": "Terms and conditions governing the use of QbD Group's website and services.",
    "noIndex": true
  },
  "/en/thank-you/contact": {
    "title": "We've received your message! | QbD Group",
    "description": "Thank you for reaching out",
    "noIndex": true
  },
  "/en/thank-you/download": {
    "title": "Your download is on the way! | QbD Group",
    "description": "Thank you for your interest",
    "noIndex": true
  },
  "/en/thank-you/signing-up": {
    "title": "You're all set! | QbD Group",
    "description": "Thank you for registering",
    "noIndex": true
  },
  "/en/thank-you/signing-up-nw": {
    "title": "Welcome aboard! | QbD Group",
    "description": "Thank you for subscribing",
    "noIndex": true
  },
  "/en/webinars": {
    "title": "Life Sciences Webinars | QbD Group",
    "description": "Watch expert-led webinars on regulatory affairs, quality assurance, clinical strategy, and more across pharma, biotech, and medical devices.",
    "ogImage": "/og-assets/webinar-hero-bg.jpg",
    "ogImageWidth": 1920,
    "ogImageHeight": 1088
  },
  "/es": {
    "title": "QbD Group — Consultoría Life Sciences | 700+ Expertos",
    "description": "QbD Group acelera la innovación en Life Sciences con 700+ expertos. Regulatory affairs, Quality Assurance, ensayos clínicos y consultoría.",
    "ogImage": "/og-assets/hero-poster.jpg",
    "ogImageWidth": 1920,
    "ogImageHeight": 1088
  },
  "/es/actualizaciones-regulatorias": {
    "title": "Actualizaciones regulatorias | QbD Group",
    "description": "Mantente al día con los cambios regulatorios que afectan a farma, dispositivos médicos e IVD — análisis experto de nuevas directrices y legislación.",
    "ogImage": "https://jrtdedcfhvzaomneervp.supabase.co/storage/v1/object/public/blog-images/regulatory-updates%2Fmdr-well-established-technologies.png"
  },
  "/es/buscar": {
    "title": "Resultados de búsqueda | QbD Group",
    "description": "Busca contenido en QbD Group",
    "noIndex": true
  },
  "/es/casos-de-exito": {
    "title": "Casos de éxito | QbD Group",
    "description": "Ejemplos reales de cómo QbD Group ayuda a empresas de Life Sciences a superar retos regulatorios y acelerar el lanzamiento al mercado.",
    "ogImage": "https://jrtdedcfhvzaomneervp.supabase.co/storage/v1/object/public/blog-images/case-studies%2Ftechdow-header.png"
  },
  "/es/certificaciones": {
    "title": "Licencias y certificaciones | QbD Group",
    "description": "QbD Group cuenta con certificaciones ISO 13485, ISO 27001, EUROTOX y GMDP, garantizando el cumplimiento normativo y la excelencia en Life Sciences.",
    "ogImage": "/og-assets/certifications-hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/es/checklist-cualificacion-sistemas-termicos-gmp": {
    "title": "Checklist de Cualificación de Sistemas Térmicos GMP | QbD Group",
    "description": "Autoevaluación gratuita: comprueba en 5 minutos si la cualificación de tus sistemas térmicos (autoclaves, cámaras de estabilidad, WFI) superaría una auditoría GMP.",
    "ogImage": "/__l5e/assets-v1/ffa59816-54b7-4ff8-bba4-15eb97c373c8/hero-thermal-gmp.png"
  },
  "/es/checklist-registro-medical-devices-recops-aemps": {
    "title": "Checklist de 10 Pasos para Registrar tus Medical Devices en España | QbD Group",
    "description": "Autoevaluación gratuita: comprueba en 5 minutos si estás preparado para registrar tus Medical Devices e IVD en España a través de RECOPS, la nueva aplicación de la AEMPS.",
    "ogImage": "/og-assets/hero-recops-checklist.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/es/codigo-de-conducta-del-proveedor": {
    "title": "Código de conducta del proveedor | QbD Group",
    "description": "Código de conducta del proveedor de QbD Group: nuestras expectativas en materia de prácticas empresariales éticas, sostenibles y responsables.",
    "noIndex": true
  },
  "/es/contacto": {
    "title": "Contacto | QbD Group",
    "description": "Ponte en contacto con QbD Group. Encuentra nuestras oficinas en todo el mundo y contacta con nuestros expertos en regulación, calidad y clínica.",
    "ogImage": "/og-assets/contact-hq.jpg",
    "ogImageWidth": 1920,
    "ogImageHeight": 1080
  },
  "/es/declaracion-de-cookies": {
    "title": "Declaración de cookies | QbD Group",
    "description": "Conoce cómo QbD Group utiliza cookies y tecnologías similares en nuestro sitio web.",
    "noIndex": true
  },
  "/es/downloads": {
    "title": "Descargas | QbD Group",
    "description": "Documentos técnicos, guías y evaluaciones de preparación sobre estrategia regulatoria, gestión de calidad y cumplimiento en la industria de Life Sciences.",
    "ogImage": "/__l5e/assets-v1/4f34be72-d9a2-4ee2-9772-6e532c4b16a9/whitepaper-fih-readiness.png"
  },
  "/es/eu-readiness-cardiology": {
    "title": "Checklist de Preparación para Ensayos Clínicos de Cardiología en la UE | QbD Group",
    "description": "Checklist gratuito de 5 minutos para promotores que planifican ensayos clínicos de cardiopatía estructural o coronaria en Europa. Resultados clínicos y regulatorios al instante.",
    "ogImage": "/og-assets/europe-map-bg.jpg",
    "ogImageWidth": 1920,
    "ogImageHeight": 1080
  },
  "/es/eu-readiness-medtech": {
    "title": "Autoevaluación de Preparación MDR para Medtech | QbD Group",
    "description": "Autoevaluación gratuita de 5 minutos para fabricantes de dispositivos médicos que entran en la UE. Evalúa tu preparación en MDR, calidad y evidencia clínica.",
    "ogImage": "/og-assets/europe-map-bg.jpg",
    "ogImageWidth": 1920,
    "ogImageHeight": 1080
  },
  "/es/eu-readiness-pharma": {
    "title": "Autoevaluación de Preparación para el Mercado Farmacéutico UE | QbD Group",
    "description": "Autoevaluación gratuita de 5 minutos para empresas farmacéuticas que entran en la UE. Evalúa tu estrategia regulatoria, GMP y calidad y obtén resultados al instante.",
    "ogImage": "/og-assets/europe-map-bg.jpg",
    "ogImageWidth": 1920,
    "ogImageHeight": 1080
  },
  "/es/eventos": {
    "title": "Calendario de eventos | QbD Group",
    "description": "Consulta el calendario de eventos de QbD Group, conferencias, congresos y eventos del sector Life Sciences.",
    "ogImage": "/og-assets/events-hero-bg.jpg",
    "ogImageWidth": 1344,
    "ogImageHeight": 768
  },
  "/es/gracias/contacto": {
    "title": "¡Hemos recibido tu mensaje! | QbD Group",
    "description": "Gracias por contactarnos",
    "noIndex": true
  },
  "/es/gracias/descarga": {
    "title": "¡Tu descarga está en camino! | QbD Group",
    "description": "Gracias por tu interés",
    "noIndex": true
  },
  "/es/gracias/registro": {
    "title": "¡Todo listo! | QbD Group",
    "description": "Gracias por registrarte",
    "noIndex": true
  },
  "/es/gracias/suscripcion": {
    "title": "¡Todo listo! | QbD Group",
    "description": "Gracias por registrarte",
    "noIndex": true
  },
  "/es/guia-completa-validacion-sistemas-informatizados": {
    "title": "Guía completa de validación de sistemas informatizados (CSV) | QbD Group",
    "description": "Domina la validación de sistemas informatizados (CSV) con esta guía exhaustiva. Aprende sobre categorías GAMP® 5, metodología del modelo V, cumplimiento GxP, integridad de datos y el ciclo de vida completo de la validación.",
    "ogImage": "/images/csv-guide/csv-background.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900,
    "ogType": "article"
  },
  "/es/industrias": {
    "title": "Industrias | QbD Group",
    "description": "QbD Group ofrece soluciones regulatorias, de calidad y cumplimiento para empresas farmacéuticas, biotecnológicas, de dispositivos médicos e IVD.",
    "ogImage": "/og-assets/industry-ivd.webp",
    "ogImageWidth": 1344,
    "ogImageHeight": 768
  },
  "/es/industrias/diagnostico-complementario": {
    "title": "PrecisionDx (CDx) | QbD Group",
    "description": "Expertise integral en diagnóstico complementario y medicina de precisión Nos especializamos en sincronizar los flujos de trabajo Pharma e IVD para asegurar la…",
    "ogImage": "/og-assets/images/heroes/hero-precision-dx.webp",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/es/industrias/in-vitro-diagnostics": {
    "title": "In Vitro Diagnostics (IVD) | QbD Group",
    "description": "La industria del In Vitro Diagnostics (IVD) evoluciona rápidamente, impulsada por innovaciones tecnológicas, complejos panoramas regulatorios y la crecient",
    "ogImage": "/og-assets/industries/in-vitro-diagnostics/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/es/industrias/medical-devices": {
    "title": "Medical Devices | QbD Group",
    "description": "¿Buscas soporte de calidad, regulatorio o clínico para tu dispositivo médico? QbD Group puede ayudarte en cualquier etapa del ciclo de vida de tu dispositi",
    "ogImage": "/og-assets/industries/medical-devices/hero.jpg",
    "ogImageWidth": 1500,
    "ogImageHeight": 1000
  },
  "/es/industrias/medical-devices/acceso-al-mercado-europeo": {
    "title": "Acceso al mercado europeo para MedTech | QbD Group",
    "description": "Navega los requisitos del MDR y el IVDR sin complicaciones El éxito bajo el MDR y el IVDR depende de la estrategia de evidencia clínica, la alineación del QMS…",
    "ogImage": "/og-assets/solutions/medtech-gateway-europe.png",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/es/industrias/medical-devices/acceso-al-mercado-europeo/china": {
    "title": "Tu socio europeo de confianza para el marcado CE y el cumplimiento del MDR/IVDR | QbD Group",
    "description": "Para empresas MedTech chinas con experiencia NMPA que entran en Europa Para fabricantes chinos de Medical Devices e IVD con aprobación NMPA o experiencia…",
    "ogImage": "/og-assets/solutions/gateway-china-hero.png",
    "ogImageWidth": 1536,
    "ogImageHeight": 1024
  },
  "/es/industrias/medical-devices/acceso-al-mercado-europeo/usa": {
    "title": "De FDA a MDR: tu entrada al mercado europeo, simplificada | QbD Group",
    "description": "Para empresas MedTech estadounidenses con experiencia FDA que entran en Europa Para empresas estadounidenses de Medical Devices y salud digital con…",
    "ogImage": "/og-assets/solutions/gateway-usa-hero.png",
    "ogImageWidth": 1536,
    "ogImageHeight": 1024
  },
  "/es/industrias/medical-devices/gestion-del-ciclo-de-vida": {
    "title": "Gestión del ciclo de vida | QbD Group",
    "description": "Soporte integral del ciclo de vida del producto Mantén tus medical devices e IVDs conformes, seguros y competitivos durante todo su ciclo de vida. QbD Group…",
    "ogImage": "/og-assets/solutions/life-cycle-management.jpg",
    "ogImageWidth": 1200,
    "ogImageHeight": 675
  },
  "/es/industrias/medical-devices/md-cro-cardiologia": {
    "title": "Tu CRO para Medical Devices de Cardiología | QbD Group",
    "description": "Como CRO europea dedicada a los Medical Devices, contamos con una profunda experiencia en investigación clínica de Medical Devices de cardiología. Desde di",
    "ogImage": "/og-assets/services/clinical-solutions/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/es/industrias/medical-devices/software-para-dispositivos-medicos": {
    "title": "Medical Device Software | QbD Group",
    "description": "Soporte integral del ciclo de vida del MDSW Los fabricantes de software de Medical Devices enfrentan una clasificación compleja, estándares en evolución y…",
    "ogImage": "/og-assets/solutions/medical-device-software.jpg",
    "ogImageWidth": 1200,
    "ogImageHeight": 675
  },
  "/es/industrias/medical-devices/startups": {
    "title": "MedTech emergente | QbD Group",
    "description": "Soporte pragmático que avanza rápido QbD Group ayuda a startups bien financiadas a construir productos listos para inversores y conformes con el marcado CE,…",
    "ogImage": "/og-assets/solutions/startups-scaleups.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/es/industrias/pharma-biotech": {
    "title": "Pharma & Biotech | QbD Group",
    "description": "Navegar por las normativas farmacéuticas y biotecnológicas requiere un profundo conocimiento. QbD Group te acompaña desde el desarrollo hasta la presentaci",
    "ogImage": "/og-assets/industries/pharma-biotech/hero.jpg",
    "ogImageWidth": 1000,
    "ogImageHeight": 1500
  },
  "/es/industrias/pharma-biotech/biotech-emergente": {
    "title": "Biotech emergente | QbD Group",
    "description": "Soporte integral de la estrategia al First-in-Human Los equipos biotech en fase temprana se mueven rápido con infraestructura limitada, lo que a menudo conduce…",
    "ogImage": "/og-assets/solutions/emerging-biotech-hero.png",
    "ogImageWidth": 600,
    "ogImageHeight": 400
  },
  "/es/industrias/pharma-biotech/cumplimiento-normativo-y-soporte-a-la-calidad-fabricacion-farmaceutica": {
    "title": "Calidad y cumplimiento en fabricación | QbD Group",
    "description": "Prepara tus operaciones de fabricación para el futuro QbD Group ayuda a fabricantes pharma y biotech a reforzar el rendimiento de fabricación a través de…",
    "ogImage": "/og-assets/solutions/mfg-hero-cleanroom.png",
    "ogImageWidth": 1200,
    "ogImageHeight": 675
  },
  "/es/industrias/pharma-biotech/gestion-del-ciclo-de-vida": {
    "title": "Gestión del ciclo de vida | QbD Group",
    "description": "Soporte integral del ciclo de vida del producto Proporcionamos soporte integral para asegurar que tus productos medicinales permanezcan seguros, conformes y…",
    "ogImage": "/og-assets/solutions/lifecycle-management-hero.png",
    "ogImageWidth": 1584,
    "ogImageHeight": 672
  },
  "/es/industrias/pharma-biotech/landing-in-europe": {
    "title": "Acceso al mercado europeo | QbD Group",
    "description": "Expande tu negocio farmacéutico a Europa con un socio que entiende tanto la estrategia como la ejecución Europa es el segundo mayor mercado farmacéutico del…",
    "ogImage": "/og-assets/solutions/market-entry-eu.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/es/industrias/pharma-biotech/landing-in-europe/us-biotech": {
    "title": "Lleva tu biotech a Europa y al Reino Unido con confianza | QbD Group",
    "description": "Expertise regulatorio, de calidad y operativo integrado para convertir el progreso en EE. UU. en preparación para el mercado europeo La expansión europea…",
    "ogImage": "/og-assets/solutions/market-entry-eu.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/es/industrias/productos-combinados": {
    "title": "Combination Products fármaco-dispositivo | QbD Group",
    "description": "Navega las vías regulatorias de la UE y EE. UU. con confianza Navegar las vías regulatorias a menudo puede sentirse como un laberinto, llevando a incertidumbre…",
    "ogImage": "/og-assets/solutions/combination-products-hero.jpg",
    "ogImageWidth": 1536,
    "ogImageHeight": 864
  },
  "/es/mapa-del-sitio": {
    "title": "Mapa del sitio | QbD Group",
    "description": "Navega por todas las páginas del sitio web de QbD Group — servicios, soluciones, industrias, recursos y más.",
    "noIndex": true
  },
  "/es/noticias": {
    "title": "Noticias de la empresa | QbD Group",
    "description": "Los últimos anuncios, alianzas e hitos de QbD Group — mantente informado sobre nuestro crecimiento e impacto."
  },
  "/es/podcasts": {
    "title": "Podcasts | QbD Group",
    "description": "Escucha debates de expertos sobre estrategia regulatoria, ensayos clínicos y gestión de calidad en la industria de Life Sciences.",
    "ogImage": "https://jrtdedcfhvzaomneervp.supabase.co/storage/v1/object/public/webinar-images/podcasts/ivds-in-clinical-trials.png"
  },
  "/es/politica-de-privacidad": {
    "title": "Privacy Policy | QbD Group",
    "description": "QbD Group's privacy policy — how we collect, use, and protect your personal data.",
    "noIndex": true
  },
  "/es/recursos": {
    "title": "Recursos | QbD Group",
    "description": "Explora recursos de expertos sobre estrategia regulatoria, gestión de calidad y cumplimiento, blogs, webinars, whitepapers, casos de éxito y más."
  },
  "/es/servicios": {
    "title": "Nuestros servicios | QbD Group",
    "description": "Servicios integrales en Life Sciences para cada fase de tu producto: desarrollo, fabricación, lanzamiento y vigilancia post-comercialización."
  },
  "/es/servicios/clinical-solutions": {
    "title": "Clinical Solutions para Medical Devices, IVD y CDx | QbD Group",
    "description": "Soporte clínico integral que ayuda a los innovadores en MedTech a avanzar desde la estrategia temprana hasta la ejecución lista para la aprobación regulato",
    "ogImage": "/og-assets/services/clinical-solutions/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/es/servicios/clinical-solutions/ensayos-clinicos-de-dispositivos-medicos": {
    "title": "Clinical Solutions para Medical Devices, IVD y CDx | QbD Group",
    "description": "Soporte clínico integral que ayuda a los innovadores en MedTech a avanzar desde la estrategia temprana hasta la ejecución lista para la aprobación regulato",
    "ogImage": "/og-assets/services/clinical-solutions/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/es/servicios/clinical-solutions/estudios-de-rendimiento-clinico-de-ivd": {
    "title": "Clinical Solutions para Medical Devices, IVD y CDx | QbD Group",
    "description": "Soporte clínico integral que ayuda a los innovadores en MedTech a avanzar desde la estrategia temprana hasta la ejecución lista para la aprobación regulato",
    "ogImage": "/og-assets/services/clinical-solutions/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/es/servicios/clinical-solutions/gestion-de-la-seguridad-clinica": {
    "title": "Gestión de la seguridad clínica — Clinical Solutions | QbD Group",
    "description": "La gestión de la seguridad clínica abarca los procesos y prácticas que garantizan la seguridad, integridad y conducta ética de las investigaciones clínicas",
    "ogImage": "/og-assets/services/clinical-solutions/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/es/servicios/clinical-solutions/gestion-y-analisis-de-datos": {
    "title": "Gestión y análisis de datos clínicos — Clinical Solutions | QbD Group",
    "description": "Nuestros servicios integrales de gestión de datos clínicos están diseñados para cubrir todo el ciclo de vida de los datos, desde la planificación y el dise",
    "ogImage": "/og-assets/services/clinical-solutions/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/es/servicios/clinical-solutions/gestión-de-la-seguridad-clínica": {
    "title": "Gestión de la seguridad clínica — Clinical Solutions | QbD Group",
    "description": "La gestión de la seguridad clínica abarca los procesos y prácticas que garantizan la seguridad, integridad y conducta ética de las investigaciones clínicas",
    "ogImage": "/og-assets/services/clinical-solutions/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/es/servicios/clinical-solutions/gestión-y-análisis-de-datos": {
    "title": "Gestión y análisis de datos clínicos — Clinical Solutions | QbD Group",
    "description": "Nuestros servicios integrales de gestión de datos clínicos están diseñados para cubrir todo el ciclo de vida de los datos, desde la planificación y el dise",
    "ogImage": "/og-assets/services/clinical-solutions/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/es/servicios/clinical-solutions/operaciones-de-estudios-clinicos": {
    "title": "Operaciones de ensayos clínicos — Clinical Solutions | QbD Group",
    "description": "Las operaciones de estudios clínicos abarcan la planificación, ejecución y gestión de los estudios clínicos. En QbD Group, nos centramos en configurar y ge",
    "ogImage": "/og-assets/services/clinical-solutions/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/es/servicios/clinical-solutions/operaciones-de-estudios-clínicos": {
    "title": "Operaciones de ensayos clínicos — Clinical Solutions | QbD Group",
    "description": "Las operaciones de estudios clínicos abarcan la planificación, ejecución y gestión de los estudios clínicos. En QbD Group, nos centramos en configurar y ge",
    "ogImage": "/og-assets/services/clinical-solutions/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/es/servicios/clinical-solutions/pmpf": {
    "title": "Seguimiento del rendimiento post-comercialización (PMPF) — Clinical Solutions | QbD Group",
    "description": "En QbD IVD | Qarad, te ayudamos a convertir el PMPF en un proceso práctico y estructurado, apoyando tu cumplimiento normativo y protegiendo los resultados",
    "ogImage": "/og-assets/services/clinical-solutions/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/es/servicios/clinical-solutions/redaccion-medica-para-diagnosticos-in-vitro": {
    "title": "Medical Writing para In Vitro Diagnostics — Clinical Solutions | QbD Group",
    "description": "En el ámbito de los IVD, contar con documentación de evidencia clínica conforme es fundamental. Nuestro equipo QbD IVD | Qarad ofrece servicios de redacció",
    "ogImage": "/og-assets/services/clinical-solutions/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/es/servicios/clinical-solutions/redaccion-medica-para-productos-sanitarios": {
    "title": "Medical Writing para Medical Devices — Clinical Solutions | QbD Group",
    "description": "Un medical writing de calidad es esencial para el cumplimiento normativo y la seguridad del paciente. Nuestro equipo ofrece servicios completos de medical",
    "ogImage": "/og-assets/services/clinical-solutions/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/es/servicios/clinical-solutions/redacción-médica-para-diagnósticos-in-vitro": {
    "title": "Medical Writing para In Vitro Diagnostics — Clinical Solutions | QbD Group",
    "description": "En el ámbito de los IVD, contar con documentación de evidencia clínica conforme es fundamental. Nuestro equipo QbD IVD | Qarad ofrece servicios de redacció",
    "ogImage": "/og-assets/services/clinical-solutions/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/es/servicios/clinical-solutions/redacción-médica-para-productos-sanitarios": {
    "title": "Medical Writing para Medical Devices — Clinical Solutions | QbD Group",
    "description": "Un medical writing de calidad es esencial para el cumplimiento normativo y la seguridad del paciente. Nuestro equipo ofrece servicios completos de medical",
    "ogImage": "/og-assets/services/clinical-solutions/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/es/servicios/clinical-solutions/seguimiento-clinico-postcomercializacion": {
    "title": "Seguimiento clínico post-comercialización (PMCF) — Clinical Solutions | QbD Group",
    "description": "Te ayudamos a navegar las complejidades del PMCF con estrategias personalizadas, eficientes y conformes con el MDR, transformando las obligaciones regulato",
    "ogImage": "/og-assets/services/clinical-solutions/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/es/servicios/clinical-solutions/seguimiento-clínico-postcomercialización": {
    "title": "Seguimiento clínico post-comercialización (PMCF) — Clinical Solutions | QbD Group",
    "description": "Te ayudamos a navegar las complejidades del PMCF con estrategias personalizadas, eficientes y conformes con el MDR, transformando las obligaciones regulato",
    "ogImage": "/og-assets/services/clinical-solutions/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/es/servicios/clinical-solutions/servicio-de-farmacovigilancia-clinica": {
    "title": "Servicio de farmacovigilancia clínica — Clinical Solutions | QbD Group",
    "description": "La farmacovigilancia es la ciencia de detectar, evaluar y prevenir los efectos adversos. En QbD Group, ofrecemos servicios completos de farmacovigilancia p",
    "ogImage": "/og-assets/services/clinical-solutions/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/es/servicios/clinical-solutions/servicios-de-calidad-clinica": {
    "title": "Servicios de calidad clínica — Clinical Solutions | QbD Group",
    "description": "¿Te resulta difícil establecer o mantener tu sistema de gestión de calidad (QMS) clínico? Nuestro equipo clínico cuenta con auditores y expertos en QA espe",
    "ogImage": "/og-assets/services/clinical-solutions/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/es/servicios/clinical-solutions/servicios-de-calidad-clínica": {
    "title": "Servicios de calidad clínica — Clinical Solutions | QbD Group",
    "description": "¿Te resulta difícil establecer o mantener tu sistema de gestión de calidad (QMS) clínico? Nuestro equipo clínico cuenta con auditores y expertos en QA espe",
    "ogImage": "/og-assets/services/clinical-solutions/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/es/servicios/clinical-solutions/servicios-de-clinicos-expertos": {
    "title": "Servicios de expertos clínicos y recursos flexibles — Clinical Solutions | QbD Group",
    "description": "Incorpora profesionales de investigación clínica a tu equipo, en los países donde los necesitas. Tú gestionas el estudio. Nosotros cubrimos el hueco.\n\nTrab",
    "ogImage": "/og-assets/services/clinical-solutions/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/es/servicios/clinical-solutions/servicios-de-clínicos-expertos": {
    "title": "Servicios de expertos clínicos y recursos flexibles — Clinical Solutions | QbD Group",
    "description": "Incorpora profesionales de investigación clínica a tu equipo, en los países donde los necesitas. Tú gestionas el estudio. Nosotros cubrimos el hueco.\n\nTrab",
    "ogImage": "/og-assets/services/clinical-solutions/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/es/servicios/clinical-solutions/servicios-de-expertos-clinicos": {
    "title": "Servicios de expertos clínicos y recursos flexibles — Clinical Solutions | QbD Group",
    "description": "Incorpora profesionales de investigación clínica a tu equipo, en los países donde los necesitas. Tú gestionas el estudio. Nosotros cubrimos el hueco.\n\nTrab",
    "ogImage": "/og-assets/services/clinical-solutions/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/es/servicios/clinical-solutions/servicios-de-regulacion-clinica": {
    "title": "Servicios regulatorios clínicos — Clinical Solutions | QbD Group",
    "description": "Gestionar las complejidades de las aprobaciones de investigaciones clínicas puede ser un reto. Agilizamos el proceso para que obtengas la autorización para",
    "ogImage": "/og-assets/services/clinical-solutions/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/es/servicios/clinical-solutions/servicios-de-regulación-clínica": {
    "title": "Servicios regulatorios clínicos — Clinical Solutions | QbD Group",
    "description": "Gestionar las complejidades de las aprobaciones de investigaciones clínicas puede ser un reto. Agilizamos el proceso para que obtengas la autorización para",
    "ogImage": "/og-assets/services/clinical-solutions/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/es/servicios/clinical-solutions/soporte-en-evidencia-clinica": {
    "title": "Soporte en evidencia clínica — Clinical Solutions | QbD Group",
    "description": "Proporcionamos soporte experto para agilizar tu estrategia de evidencia clínica y tus necesidades de medical writing, asegurando que tu dispositivo cumpla",
    "ogImage": "/og-assets/services/clinical-solutions/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/es/servicios/clinical-solutions/soporte-en-evidencia-clínica": {
    "title": "Soporte en evidencia clínica — Clinical Solutions | QbD Group",
    "description": "Proporcionamos soporte experto para agilizar tu estrategia de evidencia clínica y tus necesidades de medical writing, asegurando que tu dispositivo cumpla",
    "ogImage": "/og-assets/services/clinical-solutions/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/es/servicios/clinical-solutions/soporte-estrategia-clinica": {
    "title": "Soporte en estrategia clínica — Clinical Solutions | QbD Group",
    "description": "Estamos aquí para simplificar el proceso de definición de la estrategia clínica de tu dispositivo médico, proporcionándote la experiencia y orientación nec",
    "ogImage": "/og-assets/services/clinical-solutions/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/es/servicios/farmacovigilancia": {
    "title": "Pharmacovigilance | QbD Group",
    "description": "En QbD Group entendemos que la seguridad es primordial en un mundo de cumplimiento estricto. Desde la evaluación de riesgos pre-comercialización y la plani",
    "ogImage": "/og-assets/services/pharmacovigilance/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/es/servicios/farmacovigilancia/auditorias-fv-inspecciones-qms": {
    "title": "Pharmacovigilance (PV) Audits — Pharmacovigilance | QbD Group",
    "description": "At QbD Group, we provide certified PV audits, mock inspections, and ISO-related activities to ensure your pharmacovigilance system adheres to Good Pharmaco",
    "ogImage": "/og-assets/services/pharmacovigilance/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/es/servicios/farmacovigilancia/control-bibliografico": {
    "title": "Servicios de control bibliográfico — Pharmacovigilance | QbD Group",
    "description": "Mantente en cumplimiento con los servicios de control bibliográfico de QbD Group. Detecta señales de seguridad, garantiza la notificación puntual y potenci",
    "ogImage": "/og-assets/services/pharmacovigilance/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/es/servicios/farmacovigilancia/farmacovigilancia-formacion-combinada-certificada": {
    "title": "Farmacovigilancia y formación combinada certificada — Pharmacovigilance | QbD Group",
    "description": "En el mundo en constante evolución de la farmacovigilancia, asegurar que tu equipo esté bien formado y cumpla con las regulaciones nacionales e internacion",
    "ogImage": "/og-assets/services/pharmacovigilance/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/es/servicios/farmacovigilancia/gestion-icsr": {
    "title": "Gestión de ICSR — Pharmacovigilance | QbD Group",
    "description": "Gestionar los informes de casos de seguridad de forma eficaz es la piedra angular de la farmacovigilancia y la supervisión de ensayos clínicos. En QbD Grou",
    "ogImage": "/og-assets/services/pharmacovigilance/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/es/servicios/farmacovigilancia/informes-seguridad": {
    "title": "Safety Reporting & Signal Detection — Pharmacovigilance | QbD Group",
    "description": "Safety reporting is a critical component of pharmacovigilance and post-marketing surveillance. At QbD Group, we analyze and deliver safety reports that ens",
    "ogImage": "/og-assets/services/pharmacovigilance/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/es/servicios/farmacovigilancia/inteligencia-regulatoria": {
    "title": "Regulatory Intelligence — Pharmacovigilance | QbD Group",
    "description": "In today's fast-evolving regulatory landscape, staying compliant with international and local legislation is essential. At QbD Group, our Regulatory Intell",
    "ogImage": "/og-assets/services/pharmacovigilance/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/es/servicios/farmacovigilancia/qppv-representante-local": {
    "title": "QPPV / Servicios de representación local — Pharmacovigilance | QbD Group",
    "description": "Gestionar las responsabilidades de farmacovigilancia en múltiples regiones puede ser complejo. En QbD Vigilance, proporcionamos servicios de QPPV y represe",
    "ogImage": "/og-assets/services/pharmacovigilance/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/es/servicios/farmacovigilancia/servicios-integrales-de-informacion-medica": {
    "title": "Medical Information Services — Pharmacovigilance | QbD Group",
    "description": "Accurate, timely medical information is more than a regulatory requirement — it is a core pillar of patient safety and product trust. QbD Group combines ex",
    "ogImage": "/og-assets/services/pharmacovigilance/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/es/servicios/farmacovigilancia/servicios-qms-psmf": {
    "title": "Pharmacovigilance QMS & PSMF Services — Pharmacovigilance | QbD Group",
    "description": "Ensuring compliance with national and international pharmacovigilance regulations requires robust systems and meticulous documentation. At QbD Group, we of",
    "ogImage": "/og-assets/services/pharmacovigilance/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/es/servicios/lab-services": {
    "title": "Lab Services | QbD Group",
    "description": "Con más de 25 años de experiencia, los servicios de laboratorio de QbD Group ofrecen soluciones analíticas de alta calidad adaptadas a la industria farmacé",
    "ogImage": "/og-assets/services/lab-services/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/es/servicios/lab-services/analisis-microbiologico": {
    "title": "Servicios microbiológicos — Lab Services | QbD Group",
    "description": "QbD Group ofrece servicios expertos de ensayos microbiológicos y validación para garantizar la pureza y seguridad de tus materias primas y productos termin",
    "ogImage": "/og-assets/services/lab-services/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/es/servicios/lab-services/analisis-quimico": {
    "title": "Análisis químico de control de calidad — Lab Services | QbD Group",
    "description": "El laboratorio QC certificado GMP de QbD Group ofrece servicios fiables y precisos de análisis químico para materias primas, principios activos, IMP y prod",
    "ogImage": "/og-assets/services/lab-services/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/es/servicios/lab-services/desarrollo-metodos": {
    "title": "Desarrollo de métodos — Lab Services | QbD Group",
    "description": "QbD Group combina una profunda experiencia científica con enfoques innovadores para diseñar métodos analíticos robustos adaptados a tus necesidades específ",
    "ogImage": "/og-assets/services/lab-services/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/es/servicios/lab-services/ensayos-de-disolventes-residuales-gc": {
    "title": "Ensayos de disolventes residuales (GC) — Lab Services | QbD Group",
    "description": "Los ensayos de disolventes residuales identifican y cuantifican trazas de disolventes orgánicos tras la fabricación mediante métodos validados de GC-FID y",
    "ogImage": "/og-assets/services/lab-services/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/es/servicios/lab-services/estudios-estabilidad": {
    "title": "Estudios de estabilidad — Lab Services | QbD Group",
    "description": "QbD Group asegura que tus productos cumplan los más altos estándares de calidad mediante rigurosos estudios de estabilidad conformes con ICH, con instalaci",
    "ogImage": "/og-assets/services/lab-services/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/es/servicios/lab-services/impurezas-elementales": {
    "title": "Impurezas elementales — Lab Services | QbD Group",
    "description": "QbD Group ofrece soporte experto para analizar, controlar y mitigar las impurezas elementales de acuerdo con las directrices ICH Q3D.",
    "ogImage": "/og-assets/services/lab-services/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/es/servicios/lab-services/liberacion-de-lotes-qp": {
    "title": "Liberación de lotes QP — Lab Services | QbD Group",
    "description": "QbD Group ofrece servicios integrales de liberación de lotes por Persona Cualificada (QP), asegurando que tus productos medicinales cumplan con los estrict",
    "ogImage": "/og-assets/services/lab-services/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/es/servicios/lab-services/liberación-de-lotes-qp": {
    "title": "Liberación de lotes QP — Lab Services | QbD Group",
    "description": "QbD Group ofrece servicios integrales de liberación de lotes por Persona Cualificada (QP), asegurando que tus productos medicinales cumplan con los estrict",
    "ogImage": "/og-assets/services/lab-services/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/es/servicios/lab-services/monitorizacion-medioambiental": {
    "title": "Monitorización medioambiental — Lab Services | QbD Group",
    "description": "QbD Group está especializado en monitorización medioambiental para ayudarte a mantener el cumplimiento de salas limpias y garantizar la integridad de tus p",
    "ogImage": "/og-assets/services/lab-services/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/es/servicios/lab-services/proyectos-id": {
    "title": "Proyectos I+D — Lab Services | QbD Group",
    "description": "QbD Group aprovecha su profunda experiencia científica y las tecnologías más avanzadas para apoyar proyectos I+D farmacéuticos con soluciones a medida.",
    "ogImage": "/og-assets/services/lab-services/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/es/servicios/lab-services/validacion-limpieza": {
    "title": "Validación de la limpieza — Lab Services | QbD Group",
    "description": "QbD Group te ayuda a definir e implementar las mejores prácticas de validación de limpieza, asegurando el cumplimiento de los estándares de la industria y",
    "ogImage": "/og-assets/services/lab-services/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/es/servicios/lab-services/validacion-metodo": {
    "title": "Validación del método — Lab Services | QbD Group",
    "description": "QbD Group asegura que tus métodos analíticos estén alineados con estándares globales como ICH Q2(R1) y directrices farmacopeicas, ofreciendo resultados pre",
    "ogImage": "/og-assets/services/lab-services/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/es/servicios/pharmacovigilance/control-bibliografico": {
    "title": "Servicios de control bibliográfico — Pharmacovigilance | QbD Group",
    "description": "Mantente en cumplimiento con los servicios de control bibliográfico de QbD Group. Detecta señales de seguridad, garantiza la notificación puntual y potenci",
    "ogImage": "/og-assets/services/pharmacovigilance/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/es/servicios/pharmacovigilance/farmacovigilancia-formacion-combinada-certificada": {
    "title": "Farmacovigilancia y formación combinada certificada — Pharmacovigilance | QbD Group",
    "description": "En el mundo en constante evolución de la farmacovigilancia, asegurar que tu equipo esté bien formado y cumpla con las regulaciones nacionales e internacion",
    "ogImage": "/og-assets/services/pharmacovigilance/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/es/servicios/pharmacovigilance/gestion-icsr": {
    "title": "Gestión de ICSR — Pharmacovigilance | QbD Group",
    "description": "Gestionar los informes de casos de seguridad de forma eficaz es la piedra angular de la farmacovigilancia y la supervisión de ensayos clínicos. En QbD Grou",
    "ogImage": "/og-assets/services/pharmacovigilance/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/es/servicios/pharmacovigilance/qppv-representante-local": {
    "title": "QPPV / Servicios de representación local — Pharmacovigilance | QbD Group",
    "description": "Gestionar las responsabilidades de farmacovigilancia en múltiples regiones puede ser complejo. En QbD Vigilance, proporcionamos servicios de QPPV y represe",
    "ogImage": "/og-assets/services/pharmacovigilance/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/es/servicios/qualification-validation": {
    "title": "Qualification & Validation | QbD Group",
    "description": "Desde el commissioning de instalaciones hasta la cualificación de equipos, proporcionamos soporte escalable y flexible para asegurar que tus productos cump",
    "ogImage": "/og-assets/services/qualification-validation/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/es/servicios/qualification-validation/commissioning": {
    "title": "Commissioning — Qualification & Validation | QbD Group",
    "description": "El commissioning es fundamental para que tus sistemas y equipos funcionen al máximo rendimiento y con total seguridad en cualquier industria. En QbD Group",
    "ogImage": "/og-assets/services/qualification-validation/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/es/servicios/qualification-validation/cualificacion-de-equipos": {
    "title": "Cualificación de equipos — Qualification & Validation | QbD Group",
    "description": "¿Buscas una solución llave en mano para la parte de C&Q y cualificación de equipos de tu proyecto? Ya sea que estés construyendo o renovando y necesites cu",
    "ogImage": "/og-assets/services/qualification-validation/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/es/servicios/qualification-validation/cualificacion-de-instalaciones": {
    "title": "Cualificación de instalaciones — Qualification & Validation | QbD Group",
    "description": "En QbD Group ofrecemos servicios de cualificación de instalaciones adaptados a tu industria y requisitos regulatorios específicos. Al asociarte con nosotro",
    "ogImage": "/og-assets/services/qualification-validation/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/es/servicios/qualification-validation/cualificacion-de-servicios": {
    "title": "Cualificación de utilities — Qualification & Validation | QbD Group",
    "description": "En QbD Group ofrecemos servicios de cualificación de utilities adaptados a tu industria y requisitos regulatorios específicos. Asóciate con QbD Group para",
    "ogImage": "/og-assets/services/qualification-validation/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/es/servicios/qualification-validation/soporte-de-procesos-y-productos": {
    "title": "Soporte de procesos y productos — Qualification & Validation | QbD Group",
    "description": "Nuestro experimentado equipo ofrece experiencia en optimización de procesos, gestión de la calidad, cumplimiento normativo y metodologías de mejora continu",
    "ogImage": "/og-assets/services/qualification-validation/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/es/servicios/qualification-validation/tech-transfer": {
    "title": "Transferencia tecnológica — Qualification & Validation | QbD Group",
    "description": "La transferencia tecnológica es un proceso vital para trasladar la innovación a aplicaciones reales, impulsar el crecimiento económico y fomentar la colabo",
    "ogImage": "/og-assets/services/qualification-validation/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/es/servicios/qualification-validation/validacion-de-esterilizacion": {
    "title": "Validación de esterilización — Qualification & Validation | QbD Group",
    "description": "Nos especializamos en servicios integrales de validación de esterilización adaptados a tu industria y requisitos regulatorios específicos. La validación de",
    "ogImage": "/og-assets/services/qualification-validation/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/es/servicios/qualification-validation/validacion-de-limpieza": {
    "title": "Validación de limpieza — Qualification & Validation | QbD Group",
    "description": "QbD ofrece una amplia gama de servicios de cualificación y validación para tus procesos, aplicaciones y equipos. Nuestros expertos poseen un conocimiento p",
    "ogImage": "/og-assets/services/qualification-validation/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/es/servicios/qualification-validation/validacion-de-metodos-analiticos": {
    "title": "Validación de métodos analíticos — Qualification & Validation | QbD Group",
    "description": "Asegura que tus productos farmacéuticos cumplen los más altos estándares regulatorios con nuestros servicios integrales de validación de métodos analíticos",
    "ogImage": "/og-assets/services/qualification-validation/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/es/servicios/qualification-validation/validacion-de-procesos": {
    "title": "Validación de procesos — Qualification & Validation | QbD Group",
    "description": "¿Necesitas experiencia en validación de procesos? La validación de procesos es un componente crítico para mantener la calidad del producto, el cumplimiento",
    "ogImage": "/og-assets/services/qualification-validation/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/es/servicios/quality-assurance": {
    "title": "Quality Assurance | QbD Group",
    "description": "Desde la implementación de sistemas de gestión de calidad hasta la externalización de QA y los servicios de QP/RP, ofrecemos soluciones flexibles y escalab",
    "ogImage": "/og-assets/services/quality-assurance/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/es/servicios/quality-assurance/auditoria-calidad": {
    "title": "Auditoría de calidad — Quality Assurance | QbD Group",
    "description": "QbD Group ofrece auditores certificados y experimentados para realizar auditorías internas y de proveedores en tu nombre. Nuestros expertos en QA también p",
    "ogImage": "/og-assets/services/quality-assurance/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/es/servicios/quality-assurance/externalizacion-garantia-de-calidad": {
    "title": "Externalización del control de calidad — Quality Assurance | QbD Group",
    "description": "En QbD Group nos encargamos de tus actividades de Quality Assurance con un equipo dedicado de expertos. Desde la gestión de proveedores hasta la gestión de",
    "ogImage": "/og-assets/services/quality-assurance/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/es/servicios/quality-assurance/implementacion-qms": {
    "title": "Implementación de sistemas de gestión de calidad — Quality Assurance | QbD Group",
    "description": "En QbD Group ponemos a tu disposición expertos en QA con amplia experiencia en la creación de soluciones QMS inteligentes, eficaces y conformes, adaptadas",
    "ogImage": "/og-assets/services/quality-assurance/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/es/servicios/quality-assurance/mantenimiento-qms": {
    "title": "Actualización y mantenimiento de sistemas de gestión de la calidad — Quality Assurance | QbD Group",
    "description": "QbD Group ofrece expertos en QA con experiencia en la gestión y actualización de sistemas de gestión de calidad para garantizar el cumplimiento continuo y",
    "ogImage": "/og-assets/services/quality-assurance/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/es/servicios/quality-assurance/persona-cualificada-persona-responsable": {
    "title": "Persona Cualificada (PC) y Persona Responsable (PR) — Quality Assurance | QbD Group",
    "description": "QbD Group proporciona Personas Cualificadas y Personas Responsables con experiencia para ayudarte a cumplir los requisitos obligatorios, mantener el cumpli",
    "ogImage": "/og-assets/services/quality-assurance/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/es/servicios/quality-assurance/revision-anual-productos": {
    "title": "Revisión Anual de la Calidad del Producto (APQR / PQR) — Quality Assurance | QbD Group",
    "description": "QbD Group ofrece soporte integral para la Revisión Anual de Producto y la Revisión de Calidad de Producto — desde el análisis de datos y la redacción del P",
    "ogImage": "/og-assets/services/quality-assurance/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/es/servicios/regulatory-affairs": {
    "title": "Regulatory Affairs | QbD Group",
    "description": "Lleva tu producto al mercado con confianza gracias al soporte experto en Regulatory Affairs. Desde la estrategia hasta la aprobación del producto, ofrecemo",
    "ogImage": "/og-assets/services/regulatory-affairs/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/es/servicios/regulatory-affairs/apoyo-a-la-transición-de-mdd-a-mdr": {
    "title": "Soporte para la transición de MDD a MDR — Regulatory Affairs | QbD Group",
    "description": "El cambio de la MDD al MDR es uno de los cambios regulatorios más significativos que la industria de Medical Devices ha enfrentado en décadas. QbD Group te",
    "ogImage": "/og-assets/services/regulatory-affairs/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/es/servicios/regulatory-affairs/asesoramiento-cientifico": {
    "title": "Asesoramiento científico — Regulatory Affairs | QbD Group",
    "description": "Los procedimientos de asesoramiento científico desempeñan un papel central en el proceso de aprobación de fármacos. Nuestros consultores experimentados te",
    "ogImage": "/og-assets/services/regulatory-affairs/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/es/servicios/regulatory-affairs/asesoramiento-científico": {
    "title": "Asesoramiento científico — Regulatory Affairs | QbD Group",
    "description": "Los procedimientos de asesoramiento científico desempeñan un papel central en el proceso de aprobación de fármacos. Nuestros consultores experimentados te",
    "ogImage": "/og-assets/services/regulatory-affairs/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/es/servicios/regulatory-affairs/cumplimiento-ivdr-certificacion-ce": {
    "title": "IVDR Compliance & CE Certification — Regulatory Affairs | QbD Group",
    "description": "The EU In Vitro Diagnostic Regulation (EU) 2017/746 has fundamentally changed how in vitro diagnostics access the European market. QbD Group supports manuf",
    "ogImage": "/images/offerings/ivdr-compliance-ce-certification-ra.jpg",
    "ogImageWidth": 1408,
    "ogImageHeight": 768
  },
  "/es/servicios/regulatory-affairs/cumplimiento-mdr-certificacion-ce-para-dispositivos-medicos": {
    "title": "Cumplimiento MDR y certificación CE — Regulatory Affairs | QbD Group",
    "description": "El Reglamento Europeo de Medical Devices establece un listón más alto para la seguridad, calidad y transparencia. Ya sea que estés llevando un nuevo dispos",
    "ogImage": "/og-assets/services/regulatory-affairs/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/es/servicios/regulatory-affairs/desarrollo-de-farmacos": {
    "title": "Desarrollo de fármacos — Regulatory Affairs | QbD Group",
    "description": "El desarrollo de fármacos incluye el descubrimiento, las pruebas preclínicas y clínicas. Las nuevas entidades químicas deben demostrar estándares mínimos d",
    "ogImage": "/og-assets/services/regulatory-affairs/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/es/servicios/regulatory-affairs/desarrollo-de-fármacos": {
    "title": "Desarrollo de fármacos — Regulatory Affairs | QbD Group",
    "description": "El desarrollo de fármacos incluye el descubrimiento, las pruebas preclínicas y clínicas. Las nuevas entidades químicas deben demostrar estándares mínimos d",
    "ogImage": "/og-assets/services/regulatory-affairs/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/es/servicios/regulatory-affairs/desarrollo-en-fase-temprana": {
    "title": "Desarrollo en fase temprana — Regulatory Affairs | QbD Group",
    "description": "Un paso esencial en las primeras etapas del desarrollo de un medicamento potencial es la preparación de la solicitud de ensayo clínico para el primer estud",
    "ogImage": "/og-assets/services/regulatory-affairs/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/es/servicios/regulatory-affairs/diseño-y-desarrollo": {
    "title": "Diseño y desarrollo — Regulatory Affairs | QbD Group",
    "description": "El proceso de diseño y desarrollo es un elemento central para llevar Medical Devices e IVD seguros y efectivos al mercado. Nuestro equipo proporciona orien",
    "ogImage": "/og-assets/services/regulatory-affairs/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/es/servicios/regulatory-affairs/documentacion-tecnica": {
    "title": "Documentación técnica — Regulatory Affairs | QbD Group",
    "description": "Las nuevas regulaciones para IVD y Medical Devices introducen requisitos más estrictos para la documentación técnica y la evidencia clínica. Con más de dos",
    "ogImage": "/og-assets/services/regulatory-affairs/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/es/servicios/regulatory-affairs/documentación-técnica": {
    "title": "Documentación técnica — Regulatory Affairs | QbD Group",
    "description": "Las nuevas regulaciones para IVD y Medical Devices introducen requisitos más estrictos para la documentación técnica y la evidencia clínica. Con más de dos",
    "ogImage": "/og-assets/services/regulatory-affairs/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/es/servicios/regulatory-affairs/ectd": {
    "title": "Publicación eCTD — Regulatory Affairs | QbD Group",
    "description": "Basado en el formato del Documento Técnico Común, el eCTD transfiere información regulatoria de la industria a la agencia en formato electrónico.",
    "ogImage": "/og-assets/services/regulatory-affairs/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/es/servicios/regulatory-affairs/enfermedades-raras": {
    "title": "Enfermedades raras — Regulatory Affairs | QbD Group",
    "description": "Las enfermedades huérfanas son condiciones que afectan a un pequeño porcentaje de la población. QbD Group puede apoyarte en el desarrollo de medicamentos p",
    "ogImage": "/og-assets/services/regulatory-affairs/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/es/servicios/regulatory-affairs/estrategia-de-regulatory-affairs-en-la-industria-farmaceutica": {
    "title": "Estrategia regulatoria para Pharma — Regulatory Affairs | QbD Group",
    "description": "Establecer una estrategia regulatoria implica elegir el procedimiento adecuado para un tipo de producto, analizar las regulaciones y requisitos locales, se",
    "ogImage": "/og-assets/services/regulatory-affairs/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/es/servicios/regulatory-affairs/estrategia-de-regulatory-affairs-en-la-industria-farmacéutica": {
    "title": "Estrategia regulatoria para Pharma — Regulatory Affairs | QbD Group",
    "description": "Establecer una estrategia regulatoria implica elegir el procedimiento adecuado para un tipo de producto, analizar las regulaciones y requisitos locales, se",
    "ogImage": "/og-assets/services/regulatory-affairs/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/es/servicios/regulatory-affairs/estrategia-reguladora-para-md-e-ivd": {
    "title": "Estrategia regulatoria para MD e IVD — Regulatory Affairs | QbD Group",
    "description": "Una estrategia regulatoria es un marco esencial que delinea los pasos y acciones necesarios para abordar eficazmente los requisitos regulatorios para intro",
    "ogImage": "/og-assets/services/regulatory-affairs/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/es/servicios/regulatory-affairs/gestion-del-ciclo-de-vida": {
    "title": "Gestión del ciclo de vida — Regulatory Affairs | QbD Group",
    "description": "Los productos que han sido comercializados cambian con el tiempo y este proceso debe gestionarse. Los expertos de QbD Group te acompañan durante todo el pr",
    "ogImage": "/og-assets/services/regulatory-affairs/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/es/servicios/regulatory-affairs/gestión-del-ciclo-de-vida": {
    "title": "Gestión del ciclo de vida — Regulatory Affairs | QbD Group",
    "description": "Los productos que han sido comercializados cambian con el tiempo y este proceso debe gestionarse. Los expertos de QbD Group te acompañan durante todo el pr",
    "ogImage": "/og-assets/services/regulatory-affairs/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/es/servicios/regulatory-affairs/inteligencia-regulatoria": {
    "title": "Inteligencia regulatoria — Regulatory Affairs | QbD Group",
    "description": "La inteligencia regulatoria es esencial para un desarrollo exitoso de dispositivos y una estrategia regulatoria efectiva. Aprovechando información actualiz",
    "ogImage": "/og-assets/services/regulatory-affairs/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/es/servicios/regulatory-affairs/packaging-y-etiquetado": {
    "title": "Packaging y etiquetado — Regulatory Affairs | QbD Group",
    "description": "La Directiva 2001/83/CE exige que los textos de las etiquetas estén en conformidad con la Ficha Técnica aprobada. QbD Group te ayuda a crear artwork farmac",
    "ogImage": "/og-assets/services/regulatory-affairs/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/es/servicios/regulatory-affairs/persona-responsable-del-cumplimiento-de-la-normativa": {
    "title": "Persona responsable del cumplimiento de la normativa (PRRC) — Regulatory Affairs | QbD Group",
    "description": "Para vender productos en el mercado de la UE, los fabricantes de Medical Devices e IVD deben designar oficialmente a una PRRC. Sin una PRRC designada ofici",
    "ogImage": "/og-assets/services/regulatory-affairs/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/es/servicios/regulatory-affairs/persona-responsable-del-reino-unido-ukrp": {
    "title": "Persona responsable del Reino Unido (UKRP) — Regulatory Affairs | QbD Group",
    "description": "Tras el Brexit, los fabricantes situados fuera del Reino Unido deben designar una persona responsable del Reino Unido para comercializar Medical Devices e",
    "ogImage": "/og-assets/services/regulatory-affairs/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/es/servicios/regulatory-affairs/presentaciones-a-organismos-notificados": {
    "title": "Presentaciones a organismos notificados — Regulatory Affairs | QbD Group",
    "description": "Navegar el proceso de presentación a un organismo notificado es un paso esencial para obtener el marcado CE para Medical Devices e IVD. Ofrecemos soporte i",
    "ogImage": "/og-assets/services/regulatory-affairs/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/es/servicios/regulatory-affairs/presentaciones-regulatorias": {
    "title": "Presentaciones regulatorias — Regulatory Affairs | QbD Group",
    "description": "Navegar el panorama regulatorio para la autorización de comercialización puede ser complejo, con requisitos estrictos de documentación y cumplimiento. Nos",
    "ogImage": "/og-assets/services/regulatory-affairs/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/es/servicios/regulatory-affairs/procedimientos-regulatorios": {
    "title": "Procedimientos regulatorios — Regulatory Affairs | QbD Group",
    "description": "Existen varios procedimientos disponibles para registrar medicamentos en la UE y el Reino Unido. El método elegido depende del tipo de fármaco y la ruta pr",
    "ogImage": "/og-assets/services/regulatory-affairs/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/es/servicios/regulatory-affairs/representante-autorizado-de-suiza-ch-rep": {
    "title": "Representante autorizado de Suiza (CH-REP) — Regulatory Affairs | QbD Group",
    "description": "Los fabricantes con sede fuera de Suiza deben designar un representante autorizado suizo para comercializar Medical Devices e IVD en el mercado suizo.",
    "ogImage": "/og-assets/services/regulatory-affairs/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/es/servicios/regulatory-affairs/representante-autorizado-eu-rep": {
    "title": "Representante autorizado (EU-REP) — Regulatory Affairs | QbD Group",
    "description": "Si eres un fabricante de Medical Devices o IVD fuera de la UE/EEE, designar un representante autorizado en la UE es un requisito legal para asegurar el cum",
    "ogImage": "/og-assets/services/regulatory-affairs/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/es/servicios/regulatory-affairs/representante-legal": {
    "title": "Representante legal — Regulatory Affairs | QbD Group",
    "description": "Para los promotores de estudios de rendimiento con sede fuera de la Unión Europea, designar un representante legal dentro de la Unión es un requisito regul",
    "ogImage": "/og-assets/services/regulatory-affairs/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/es/servicios/regulatory-affairs/responsable-de-información": {
    "title": "Responsable de información — Regulatory Affairs | QbD Group",
    "description": "Para cumplir plenamente con los requisitos legales, un experto cualificado debe asumir la responsabilidad sobre cómo se comunica y comercializa la informac",
    "ogImage": "/og-assets/services/regulatory-affairs/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/es/servicios/regulatory-affairs/revisión-lingüística": {
    "title": "Revisión lingüística — Regulatory Affairs | QbD Group",
    "description": "Uno de los mayores retos en el proceso de revisión lingüística es el plazo de entrega extremadamente corto para las traducciones. QbD Group asegura traducc",
    "ogImage": "/og-assets/services/regulatory-affairs/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/es/servicios/regulatory-affairs/servicios-de-representacion-en-el-pais": {
    "title": "Servicios de representación en el país — Regulatory Affairs | QbD Group",
    "description": "Nuestros expertos regulatorios actúan como EU-REP/UKRP/CH-REP para facilitar el acceso de dispositivos IVD y MD a los mercados europeo, del Reino Unido y s",
    "ogImage": "/og-assets/services/regulatory-affairs/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/es/servicios/regulatory-affairs/servicios-de-representación-en-el-país": {
    "title": "Servicios de representación en el país — Regulatory Affairs | QbD Group",
    "description": "Nuestros expertos regulatorios actúan como EU-REP/UKRP/CH-REP para facilitar el acceso de dispositivos IVD y MD a los mercados europeo, del Reino Unido y s",
    "ogImage": "/og-assets/services/regulatory-affairs/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/es/servicios/regulatory-affairs/soporte-para-la-transición-de-ivdd-a-ivdr": {
    "title": "Soporte para la transición de IVDD a IVDR — Regulatory Affairs | QbD Group",
    "description": "Con plazos de certificación promedio de 13 a 18 meses y fechas límite de transición que se acercan rápidamente, los fabricantes de IVD no pueden permitirse",
    "ogImage": "/og-assets/services/regulatory-affairs/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/es/servicios/regulatory-affairs/vigilancia-poscomercialización": {
    "title": "Vigilancia poscomercialización — Regulatory Affairs | QbD Group",
    "description": "La vigilancia poscomercialización es un requisito esencial para garantizar la seguridad y eficacia continuas de tu IVD o dispositivo médico una vez que lle",
    "ogImage": "/og-assets/services/regulatory-affairs/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/es/servicios/software-solutions-services": {
    "title": "Software Solutions & Services | QbD Group",
    "description": "No te quedes atrás en la transformación digital de la industria de Life Sciences. QbD Group aprovecha su profunda experiencia en procesos de negocio, requi",
    "ogImage": "/og-assets/services/software-solutions-services/hero.jpg",
    "ogImageWidth": 1536,
    "ogImageHeight": 864
  },
  "/es/servicios/software-solutions-services/conformidad-del-software-de-dispositivos-medicos": {
    "title": "Conformidad del software de dispositivos médicos — Software Solutions & Services | QbD Group",
    "description": "Nuestro servicio de conformidad del software de dispositivos médicos ayuda a las empresas de MD e IVD a garantizar que su software se alinee con MDR, IVDR,",
    "ogImage": "/og-assets/services/software-solutions-services/medical-device-software-compliance.png",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/es/servicios/software-solutions-services/conformidad-del-software-de-dispositivos-médicos": {
    "title": "Conformidad del software de dispositivos médicos — Software Solutions & Services | QbD Group",
    "description": "Nuestro servicio de conformidad del software de dispositivos médicos ayuda a las empresas de MD e IVD a garantizar que su software se alinee con MDR, IVDR,",
    "ogImage": "/og-assets/services/software-solutions-services/medical-device-software-compliance.png",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/es/servicios/software-solutions-services/cualificacion-de-la-infraestructura-informatica": {
    "title": "Cualificación de la infraestructura informática — Software Solutions & Services | QbD Group",
    "description": "En el entorno altamente regulado de hoy, asegurar la fiabilidad y el cumplimiento de la infraestructura de TI es un reto creciente. QbD Group ofrece experi",
    "ogImage": "/og-assets/services/software-solutions-services/it-infrastructure-qualification.jpg",
    "ogImageWidth": 1344,
    "ogImageHeight": 768
  },
  "/es/servicios/software-solutions-services/cualificación-de-la-infraestructura-informática": {
    "title": "Cualificación de la infraestructura informática — Software Solutions & Services | QbD Group",
    "description": "En el entorno altamente regulado de hoy, asegurar la fiabilidad y el cumplimiento de la infraestructura de TI es un reto creciente. QbD Group ofrece experi",
    "ogImage": "/og-assets/services/software-solutions-services/it-infrastructure-qualification.jpg",
    "ogImageWidth": 1344,
    "ogImageHeight": 768
  },
  "/es/servicios/software-solutions-services/cumplimiento-de-software-operativo": {
    "title": "Cumplimiento del Software Operativo — Software Solutions & Services | QbD Group",
    "description": "Mantener el cumplimiento de los estándares regulatorios no es tarea fácil. Los servicios de cumplimiento del software operativo de QbD Group garantizan que",
    "ogImage": "/og-assets/services/software-solutions-services/operational-software-compliance.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/es/servicios/software-solutions-services/cumplimiento-ia": {
    "title": "Cumplimiento IA/ML — Software Solutions & Services | QbD Group",
    "description": "En el mundo en rápida evolución de la IA y el machine learning, desarrollar soluciones de software que cumplan los estándares regulatorios es crucial. QbD",
    "ogImage": "/og-assets/services/software-solutions-services/ai-ml-compliance.jpg",
    "ogImageWidth": 1344,
    "ogImageHeight": 768
  },
  "/es/servicios/software-solutions-services/digitalizacion": {
    "title": "Digitalización — Software Solutions & Services | QbD Group",
    "description": "QbD Group ayuda a las empresas de Life Sciences a modernizar y optimizar sus operaciones. Nuestras soluciones de digitalización a medida garantizan una tra",
    "ogImage": "/og-assets/services/software-solutions-services/digitalization-what.png",
    "ogImageWidth": 1200,
    "ogImageHeight": 675
  },
  "/es/servicios/software-solutions-services/digitalización": {
    "title": "Digitalización — Software Solutions & Services | QbD Group",
    "description": "QbD Group ayuda a las empresas de Life Sciences a modernizar y optimizar sus operaciones. Nuestras soluciones de digitalización a medida garantizan una tra",
    "ogImage": "/og-assets/services/software-solutions-services/digitalization-what.png",
    "ogImageWidth": 1200,
    "ogImageHeight": 675
  },
  "/es/servicios/software-solutions-services/gobernanza-de-datos": {
    "title": "Gobernanza de datos — Software Solutions & Services | QbD Group",
    "description": "¿Te preocupa mantenerte al día con las regulaciones de datos complejas y cambiantes? QbD Group ofrece soporte de gobernanza de datos que te ayuda a cumplir",
    "ogImage": "/og-assets/services/software-solutions-services/data-governance.jpg",
    "ogImageWidth": 1344,
    "ogImageHeight": 768
  },
  "/es/servicios/software-solutions-services/ifucare": {
    "title": "IFUcare — Electronic IFU Solution — Software Solutions & Services | QbD Group",
    "description": "IFUcare offers a seamless electronic IFU service for medical device and IVD manufacturers, empowering you to leave paper IFUs behind and transition to comp",
    "ogImage": "/og-assets/services/software-solutions-services/ifucare-mockup.jpg",
    "ogImageWidth": 1000,
    "ogImageHeight": 600
  },
  "/es/servicios/software-solutions-services/implementacion-de-software": {
    "title": "Implementaciones de software — Software Solutions & Services | QbD Group",
    "description": "Las implementaciones de software son esenciales para que las organizaciones modernas de Life Sciences sigan siendo competitivas. Nuestro equipo de expertos",
    "ogImage": "/og-assets/services/software-solutions-services/software-implementations.png",
    "ogImageWidth": 600,
    "ogImageHeight": 400
  },
  "/es/servicios/software-solutions-services/implementación-de-software": {
    "title": "Implementaciones de software — Software Solutions & Services | QbD Group",
    "description": "Las implementaciones de software son esenciales para que las organizaciones modernas de Life Sciences sigan siendo competitivas. Nuestro equipo de expertos",
    "ogImage": "/og-assets/services/software-solutions-services/software-implementations.png",
    "ogImageWidth": 600,
    "ogImageHeight": 400
  },
  "/es/servicios/software-solutions-services/integridad-de-datos": {
    "title": "Integridad de datos — Software Solutions & Services | QbD Group",
    "description": "La integridad de datos es más crítica que nunca, desde equipos y sistemas de laboratorio hasta sistemas automatizados e infraestructura de TI. QbD Group of",
    "ogImage": "/og-assets/services/software-solutions-services/data-integrity.jpg",
    "ogImageWidth": 1344,
    "ogImageHeight": 768
  },
  "/es/servicios/software-solutions-services/scilife": {
    "title": "Scilife™ — Quality Management Software — Software Solutions & Services | QbD Group",
    "description": "Scilife™ is a user-friendly, all-in-one Quality Management Software designed to streamline every aspect of your workflow — from document control and traini",
    "ogImage": "/og-assets/services/software-solutions-services/scilife-mockup.png",
    "ogImageWidth": 1280,
    "ogImageHeight": 720
  },
  "/es/servicios/software-solutions-services/validacion-de-software-y-sistemas-informaticos": {
    "title": "Validación de software y sistemas informáticos centralizados — Software Solutions & Services | QbD Group",
    "description": "La validación de software es más crítica que nunca, desde la automatización y la digitalización hasta la inteligencia artificial y el machine learning. QbD",
    "ogImage": "/og-assets/services/software-solutions-services/software-validation.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/es/servicios/software-solutions-services/validacion-sin-papel": {
    "title": "Validación sin papel — Software Solutions & Services | QbD Group",
    "description": "La validación sin papel ofrece un enfoque digital que revoluciona el proceso de validación en industrias reguladas. Despídete de la documentación en papel",
    "ogImage": "/og-assets/services/software-solutions-services/paperless-validation.jpg",
    "ogImageWidth": 1344,
    "ogImageHeight": 768
  },
  "/es/servicios/software-solutions-services/validación-de-software-y-sistemas-informáticos": {
    "title": "Validación de software y sistemas informáticos centralizados — Software Solutions & Services | QbD Group",
    "description": "La validación de software es más crítica que nunca, desde la automatización y la digitalización hasta la inteligencia artificial y el machine learning. QbD",
    "ogImage": "/og-assets/services/software-solutions-services/software-validation.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/es/servicios/software-solutions-services/validación-sin-papel": {
    "title": "Validación sin papel — Software Solutions & Services | QbD Group",
    "description": "La validación sin papel ofrece un enfoque digital que revoluciona el proceso de validación en industrias reguladas. Despídete de la documentación en papel",
    "ogImage": "/og-assets/services/software-solutions-services/paperless-validation.jpg",
    "ogImageWidth": 1344,
    "ogImageHeight": 768
  },
  "/es/servicios/toxicologia-regulatoria": {
    "title": "Toxicología Regulatoria | QbD Group",
    "description": "Desde informes PDE/ADE hasta evaluaciones de riesgo de nitrosaminas y registro REACH, nuestro equipo de toxicólogos certificados EUROTOX ofrece informes ci",
    "ogImage": "/og-assets/hubs/services-toxicology.jpg",
    "ogImageWidth": 1200,
    "ogImageHeight": 630
  },
  "/es/servicios/toxicologia-regulatoria/estudios-de-seguimiento": {
    "title": "Estudios de seguimiento — Toxicología Regulatoria | QbD Group",
    "description": "QbD Group proporciona soporte experto para el seguimiento de estudios de laboratorio requeridos en la fabricación y calidad de medicamentos, incluyendo val"
  },
  "/es/servicios/toxicologia-regulatoria/evaluacion-de-riesgos-de-las-nitrosaminas": {
    "title": "Evaluación del riesgo de las nitrosaminas — Toxicología Regulatoria | QbD Group",
    "description": "QbD Group se especializa en evaluaciones de riesgo de nitrosaminas, ayudando a las empresas farmacéuticas a identificar riesgos, redactar informes, calcula"
  },
  "/es/servicios/toxicologia-regulatoria/evaluacion-de-riesgos-medioambientales-era": {
    "title": "Evaluación del riesgo medioambiental (ERA) — Toxicología Regulatoria | QbD Group",
    "description": "QbD Group apoya a las empresas farmacéuticas a lo largo de todo el ciclo de vida del ERA, combinando experiencia científica con un enfoque práctico y basad"
  },
  "/es/servicios/toxicologia-regulatoria/evaluación-de-riesgos-de-las-nitrosaminas": {
    "title": "Evaluación del riesgo de las nitrosaminas — Toxicología Regulatoria | QbD Group",
    "description": "QbD Group se especializa en evaluaciones de riesgo de nitrosaminas, ayudando a las empresas farmacéuticas a identificar riesgos, redactar informes, calcula"
  },
  "/es/servicios/toxicologia-regulatoria/evaluación-de-riesgos-medioambientales-era": {
    "title": "Evaluación del riesgo medioambiental (ERA) — Toxicología Regulatoria | QbD Group",
    "description": "QbD Group apoya a las empresas farmacéuticas a lo largo de todo el ciclo de vida del ERA, combinando experiencia científica con un enfoque práctico y basad"
  },
  "/es/servicios/toxicologia-regulatoria/informes-pde-oel": {
    "title": "Informes PDE-OEL — Toxicología Regulatoria | QbD Group",
    "description": "QbD Group prepara informes PDE/ADE para cualquier principio activo farmacéutico conforme a las directivas de la EMA. Nuestros toxicólogos certificados ERT"
  },
  "/es/servicios/toxicologia-regulatoria/informes-sobre-disolventes-residuales": {
    "title": "Informes sobre disolventes residuales — Toxicología Regulatoria | QbD Group",
    "description": "QbD Group se especializa en evaluaciones de riesgo de disolventes residuales en productos farmacéuticos de uso humano y veterinario, ayudando a identificar"
  },
  "/es/servicios/toxicologia-regulatoria/informes-sobre-extractables-y-lixiviables": {
    "title": "Informes sobre extractables y lixiviables — Toxicología Regulatoria | QbD Group",
    "description": "QbD Group proporciona evaluaciones toxicológicas y de riesgo para impurezas extractables y lixiviables, diseñadas para adaptarse a tus necesidades específi"
  },
  "/es/servicios/toxicologia-regulatoria/informes-sobre-impurezas-elementales": {
    "title": "Informes sobre impurezas elementales — Toxicología Regulatoria | QbD Group",
    "description": "QbD Group proporciona evaluaciones de riesgos e informes integrales sobre impurezas elementales en productos farmacéuticos de uso humano y veterinario, ase"
  },
  "/es/servicios/toxicologia-regulatoria/informes-sobre-impurezas-organicas": {
    "title": "Informes sobre impurezas orgánicas — Toxicología Regulatoria | QbD Group",
    "description": "QbD Group ofrece la mayor biblioteca online de informes de toxicología de alta calidad certificados por miembros de AETOX, que cubren evaluaciones de riesg"
  },
  "/es/servicios/toxicologia-regulatoria/informes-sobre-impurezas-orgánicas": {
    "title": "Informes sobre impurezas orgánicas — Toxicología Regulatoria | QbD Group",
    "description": "QbD Group ofrece la mayor biblioteca online de informes de toxicología de alta calidad certificados por miembros de AETOX, que cubren evaluaciones de riesg"
  },
  "/es/servicios/toxicologia-regulatoria/registro-reach-y-apoyo-al-cumplimiento": {
    "title": "Registro REACH y apoyo al cumplimiento — Toxicología Regulatoria | QbD Group",
    "description": "QbD Group te ayuda a navegar cada paso del registro REACH, desde la caracterización de sustancias y la elaboración del dossier IUCLID hasta la redacción de"
  },
  "/es/sobre-qbd": {
    "title": "Sobre QbD Group | Consultoría Life Sciences",
    "description": "Fundado en 2011, QbD Group es un socio de confianza para las industrias de Life Sciences y salud, con más de 600 expertos en 11 oficinas en todo el mundo.",
    "ogImage": "/og-assets/about-team.jpg",
    "ogImageWidth": 1080,
    "ogImageHeight": 1350
  },
  "/es/sobre-qbd/consejo-asesor": {
    "title": "Consejo asesor — QbD Group",
    "description": "Conoce al consejo asesor de QbD Group — líderes reconocidos de la industria que proporcionan asesoramiento estratégico para fortalecer nuestra posición en Life Sciences.",
    "ogImage": "/og-assets/board/board-hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/es/sobre-qbd/ecosistema": {
    "title": "Ecosistema | Socios y empresas de QbD Group",
    "description": "Descubre el ecosistema integral de empresas y socios estratégicos de QbD Group que aportan experiencia en toda la industria Life Sciences.",
    "ogImage": "/og-assets/about-ecosystem.png",
    "ogImageWidth": 900,
    "ogImageHeight": 600
  },
  "/es/sobre-qbd/equipo": {
    "title": "Nuestro equipo | Liderazgo de QbD Group",
    "description": "Conoce al equipo directivo de QbD Group, más de 600 consultores expertos en 11 oficinas, liderados por profesionales que impulsan la visión estratégica en Life Sciences.",
    "ogImage": "/og-assets/about-team.jpg",
    "ogImageWidth": 1080,
    "ogImageHeight": 1350
  },
  "/es/sobre-qbd/fundacion": {
    "title": "QbD Group Foundation | Marcando la diferencia",
    "description": "La QbD Group Foundation apoya la ciencia, ayuda a personas que enfrentan amenazas para su salud, protege el medio ambiente y monitoriza el compromiso social de la organización.",
    "ogImage": "/og-assets/foundation-hero.jpg",
    "ogImageWidth": 1920,
    "ogImageHeight": 1080
  },
  "/es/sobre-qbd/historia": {
    "title": "Nuestra historia | Historia y fundadores de QbD Group",
    "description": "Descubre cómo QbD Group fue fundado en 2011 por Bart Van Acker y ha crecido hasta convertirse en una consultora Life Sciences con más de 600 empleados y oficinas en todo el mundo.",
    "ogImage": "/og-assets/story/bart-hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 1600
  },
  "/es/solicita-tu-auditoria": {
    "title": "Solicita tu auditoría – Servicios de auditoría GxP, ISO y MDR | QbD Group",
    "description": "Solicita tu auditoría independiente para pharma, MedTech o biotech. Los auditores certificados de QbD Group realizan auditorías ISO, GxP y MDR en todo el mundo. Respuesta en 1 día laborable."
  },
  "/es/soluciones": {
    "title": "Soluciones Life Sciences | QbD Group",
    "description": "Soluciones regulatorias, de calidad y de acceso al mercado para Pharma, Biotech, dispositivos médicos e IVD."
  },
  "/es/suscribete": {
    "title": "Newsletter | Insights en Life Sciences | QbD Group",
    "description": "Suscríbete a la newsletter de QbD Group para recibir insights regulatorios, orientación en cumplimiento normativo y análisis de la industria directamente en tu bandeja de entrada."
  },
  "/es/suscribirse": {
    "title": "Newsletter | Insights en Life Sciences | QbD Group",
    "description": "Suscríbete a la newsletter de QbD Group para recibir insights regulatorios, orientación en cumplimiento normativo y análisis de la industria directamente en tu bandeja de entrada."
  },
  "/es/terminos-y-condiciones": {
    "title": "Términos y Condiciones | QbD Group",
    "description": "Términos y condiciones que regulan el uso del sitio web y los servicios de QbD Group.",
    "noIndex": true
  },
  "/es/webinars": {
    "title": "Webinars de Life Sciences | QbD Group",
    "description": "Accede a webinars dirigidos por expertos sobre regulatory affairs, calidad, estrategia clínica y más en farma, biotecnología y Medical Devices.",
    "ogImage": "/og-assets/webinar-hero-bg.jpg",
    "ogImageWidth": 1920,
    "ogImageHeight": 1088
  },
  "/filming-tips": {
    "title": "Filming Tips | QbD Group",
    "description": "A quick practical guide to help QbD Group employees record a good self-filmed video for an internal campaign.",
    "ogImage": "/og-assets/filming-tips-hero.jpg",
    "ogImageWidth": 1920,
    "ogImageHeight": 1088,
    "noIndex": true
  },
  "/knowledge-center": {
    "title": "Knowledge Center | QbD Group",
    "description": "Explore expert resources on regulatory strategy, quality management, and compliance, blogs, webinars, white papers, case studies, and more."
  },
  "/sitemap": {
    "title": "Sitemap | QbD Group",
    "description": "Navigate all pages on the QbD Group website — services, solutions, industries, knowledge center, and more.",
    "noIndex": true
  },
  "/zh-cn": {
    "title": "QbD Group — 生命科学咨询 | 700+专家",
    "description": "QbD Group拥有700多位专家，加速生命科学创新。提供法规事务、质量保证、临床试验及合规咨询，从创意到患者。",
    "ogImage": "/og-assets/hero-poster.jpg",
    "ogImageWidth": 1920,
    "ogImageHeight": 1088
  },
  "/zh-cn/about-qbd": {
    "title": "关于 QbD Group — 生命科学咨询合作伙伴",
    "description": "QbD Group 成立于2011年，是生命科学和医疗健康行业值得信赖的合作伙伴，拥有700多名专家，遍布全球11个办事处。",
    "ogImage": "/og-assets/about-team.jpg",
    "ogImageWidth": 1080,
    "ogImageHeight": 1350
  },
  "/zh-cn/about-qbd/board-of-advisors": {
    "title": "顾问委员会 — QbD Group",
    "description": "认识 QbD Group 的顾问委员会 — 受人尊敬的行业领袖,他们提供战略建议,助力我们在生命科学行业中巩固地位。",
    "ogImage": "/og-assets/board/board-hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/zh-cn/about-qbd/ecosystem": {
    "title": "生态系统 | QbD Group 合作伙伴与公司",
    "description": "了解 QbD Group 的综合生态系统——旗下公司与战略合作伙伴在生命科学行业提供全方位专业能力。",
    "ogImage": "/og-assets/about-ecosystem.png",
    "ogImageWidth": 900,
    "ogImageHeight": 600
  },
  "/zh-cn/about-qbd/qbd-group-foundation": {
    "title": "QbD Group Foundation | 创造改变",
    "description": "QbD Group Foundation 支持科学发展,帮助面临健康威胁的个人,保护环境,并监督整个组织的社会承诺。",
    "ogImage": "/og-assets/foundation-hero.jpg",
    "ogImageWidth": 1920,
    "ogImageHeight": 1080
  },
  "/zh-cn/about-qbd/story": {
    "title": "我们的故事 | QbD Group 的历史与创始人",
    "description": "了解 QbD Group 如何由 Bart Van Acker 于2011年创立，并发展成为一家拥有700多名员工、办事处遍布全球的生命科学咨询公司。",
    "ogImage": "/og-assets/story/bart-hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 1600
  },
  "/zh-cn/about-qbd/team": {
    "title": "我们的团队 | QbD Group 领导层",
    "description": "认识 QbD Group 背后的领导团队——700多名专家顾问遍布11个办事处，由经验丰富的专业人员引领生命科学领域的战略愿景。",
    "ogImage": "/og-assets/about-team.jpg",
    "ogImageWidth": 1080,
    "ogImageHeight": 1350
  },
  "/zh-cn/case-studies": {
    "title": "案例研究 | QbD Group",
    "description": "QbD Group如何帮助生命科学公司应对监管挑战并加速市场推出的真实案例。"
  },
  "/zh-cn/certifications": {
    "title": "许可证与认证 | QbD Group",
    "description": "QbD Group 持有 ISO 13485、ISO 27001、EUROTOX 和 GMDP 认证，确保生命科学领域的合规性和产品卓越性。",
    "ogImage": "/og-assets/certifications-hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/zh-cn/contact": {
    "title": "联系我们 | QbD Group",
    "description": "联系 QbD Group。查找我们全球办事处，与法规、质量和临床专家取得联系。",
    "ogImage": "/og-assets/contact-hq.jpg",
    "ogImageWidth": 1920,
    "ogImageHeight": 1080
  },
  "/zh-cn/downloads": {
    "title": "下载 | QbD Group",
    "description": "关于监管策略、质量管理和合规性的深入技术文件、指南和准备度评估。",
    "ogImage": "/__l5e/assets-v1/4f34be72-d9a2-4ee2-9772-6e532c4b16a9/whitepaper-fih-readiness.png"
  },
  "/zh-cn/industries": {
    "title": "我们服务的行业 | QbD Group",
    "description": "QbD Group 为制药、生物技术、医疗器械、IVD、伴随诊断和组合产品企业提供量身定制的法规和质量解决方案。",
    "ogImage": "/og-assets/industry-ivd.webp",
    "ogImageWidth": 1344,
    "ogImageHeight": 768
  },
  "/zh-cn/industries/combination-products": {
    "title": "药物-器械组合产品 | QbD Group",
    "description": "自信导航欧盟和美国法规路径 导航法规路径常常感觉像是在迷宫中穿行，导致递交过程中的不确定性和潜在错误。对于组合产品来说更是如此。在QbD…",
    "ogImage": "/og-assets/solutions/combination-products-hero.jpg",
    "ogImageWidth": 1536,
    "ogImageHeight": 864
  },
  "/zh-cn/industries/companion-diagnostics": {
    "title": "PrecisionDx（CDx） | QbD Group",
    "description": "端到端的伴随诊断与精准医疗专业能力 我们专注于协同制药与 IVD…",
    "ogImage": "/og-assets/images/heroes/hero-precision-dx.webp",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/zh-cn/industries/in-vitro-diagnostics": {
    "title": "体外诊断 | QbD Group",
    "description": "应对 IVDR 复杂性需要深厚的法规知识和实操经验。QbD Group 支持 IVD 制造商从产品开发到上市后合规，确保您的产品满足所有欧盟法规要求。",
    "ogImage": "/og-assets/industries/in-vitro-diagnostics/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/zh-cn/industries/medical-devices": {
    "title": "医疗器械 | QbD Group",
    "description": "寻找医疗器械的质量、法规或临床支持？QbD Group 可以在医疗器械生命周期的任何阶段为您提供帮助，从创意到患者。我们是 ISO 13485、临床评估/调查、MDR、设计与开发、技术文件、审计、确认、验证、风险管理、软件等方面的专家。",
    "ogImage": "/og-assets/industries/medical-devices/hero.jpg",
    "ogImageWidth": 1500,
    "ogImageHeight": 1000
  },
  "/zh-cn/industries/pharma-biotech": {
    "title": "制药与生物技术 | QbD Group",
    "description": "应对制药和生物技术法规需要深厚的专业知识。QbD Group 从开发到法规提交再到上市后合规，为您提供全程支持，确保在每个阶段都符合 EMA 和 ICH 指南。",
    "ogImage": "/og-assets/industries/pharma-biotech/hero.jpg",
    "ogImageWidth": 1000,
    "ogImageHeight": 1500
  },
  "/zh-cn/industries/pharma-biotech/landing-in-europe": {
    "title": "进入欧洲市场 | QbD Group",
    "description": "与深谙战略与执行的合作伙伴一同拓展欧洲药品市场…",
    "ogImage": "/og-assets/solutions/market-entry-eu.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/zh-cn/industries/pharma-biotech/landing-in-europe/us-biotech": {
    "title": "自信地将您的生物技术带入欧洲和英国 | QbD Group",
    "description": "一体化的法规、质量和运营专业知识，将美国的发展势头转化为欧洲市场准备…",
    "ogImage": "/og-assets/solutions/market-entry-eu.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/zh-cn/knowledge-center": {
    "title": "知识中心 | QbD Group",
    "description": "探索关于法规策略、质量管理与合规的专家资源，包括博客、网络研讨会、白皮书、案例研究等。"
  },
  "/zh-cn/news": {
    "title": "公司新闻 | QbD Group",
    "description": "QbD Group 的最新公告、合作伙伴关系和重要里程碑——及时了解我们的发展与影响力。"
  },
  "/zh-cn/newsletter": {
    "title": "Newsletter | 生命科学洞察 | QbD Group",
    "description": "订阅QbD Group通讯，获取专家法规洞察、合规指导和行业分析。"
  },
  "/zh-cn/regulatory-updates": {
    "title": "法规更新 | QbD Group",
    "description": "及时了解影响制药、医疗器械和体外诊断领域的法规变化——对新指南和立法的专家分析。"
  },
  "/zh-cn/request-your-audit": {
    "title": "申请您的审计 – 全球 GxP、ISO 与 MDR 审计服务 | QbD Group",
    "description": "为制药、MedTech 或生物技术申请独立审计。QbD Group 的认证审计员在全球开展 ISO、GxP 和 MDR 审计,1 个工作日内回复。"
  },
  "/zh-cn/services": {
    "title": "我们的服务 | QbD Group",
    "description": "全面的生命科学服务，支持您产品旅程的每一个阶段——从早期开发到制造、市场推出和上市后监测。"
  },
  "/zh-cn/services/clinical-solutions/clinical-evidence-support": {
    "title": "Clinical Evidence Support — Clinical Solutions | QbD Group",
    "description": "We provide expert support to streamline your clinical evidence strategy and medical writing needs, ensuring that your device meets regulatory expectations",
    "ogImage": "/og-assets/services/clinical-solutions/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/zh-cn/services/clinical-solutions/clinical-expert-services": {
    "title": "Clinical Expert Services and Flexible Resourcing — Clinical Solutions | QbD Group",
    "description": "Add clinical research professionals to your team, in the countries where you need them. You manage the study. We fill the gap.\n\nWe work with medical device",
    "ogImage": "/og-assets/services/clinical-solutions/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/zh-cn/services/clinical-solutions/clinical-pharmacovigilance-service": {
    "title": "Clinical Pharmacovigilance Service — Clinical Solutions | QbD Group",
    "description": "Pharmacovigilance is the science of detecting, assessing, and preventing adverse effects. At QbD Group, we offer full pharmacovigilance services for the sa",
    "ogImage": "/og-assets/services/clinical-solutions/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/zh-cn/services/clinical-solutions/clinical-quality-services": {
    "title": "Clinical Quality Services — Clinical Solutions | QbD Group",
    "description": "Struggling to establish or maintain your Clinical Quality Management System (QMS)? Our clinical team has auditors and QA experts who specialize in providin",
    "ogImage": "/og-assets/services/clinical-solutions/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/zh-cn/services/clinical-solutions/clinical-regulatory-services": {
    "title": "Clinical Regulatory Services — Clinical Solutions | QbD Group",
    "description": "Handling the complexities of clinical investigation approvals can be daunting. We streamline the process, ensuring you get the green light to start your st",
    "ogImage": "/og-assets/services/clinical-solutions/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/zh-cn/services/clinical-solutions/clinical-safety-management": {
    "title": "Clinical Safety Management — Clinical Solutions | QbD Group",
    "description": "Clinical Safety Management encompasses the processes and practices that ensure the safety, integrity, and ethical conduct of clinical investigations. We su",
    "ogImage": "/og-assets/services/clinical-solutions/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/zh-cn/services/clinical-solutions/clinical-strategy-support": {
    "title": "Clinical Strategy Support — Clinical Solutions | QbD Group",
    "description": "We are here to simplify the process of defining clinical strategy for your medical device, providing the expertise and guidance you need to define a robust",
    "ogImage": "/og-assets/services/clinical-solutions/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/zh-cn/services/clinical-solutions/clinical-study-operations": {
    "title": "Clinical Trial Operations — Clinical Solutions | QbD Group",
    "description": "Clinical study operations encompass the planning, execution, and management of clinical studies. At QbD Group, we focus on setting up and managing your cli",
    "ogImage": "/og-assets/services/clinical-solutions/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/zh-cn/services/clinical-solutions/data-management-and-analysis": {
    "title": "Clinical Data Management and Analysis — Clinical Solutions | QbD Group",
    "description": "Our comprehensive clinical data management services are designed to support the entire data lifecycle, from planning and CRF design to data handling, clean",
    "ogImage": "/og-assets/services/clinical-solutions/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/zh-cn/services/clinical-solutions/medical-writing-for-in-vitro-diagnostics": {
    "title": "Medical Writing for In Vitro Diagnostics — Clinical Solutions | QbD Group",
    "description": "When it comes to IVDs, having compliant clinical evidence documentation is critical. Our QbD IVD | Qarad team offers writing, consulting, and documentation",
    "ogImage": "/og-assets/services/clinical-solutions/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/zh-cn/services/clinical-solutions/medical-writing-for-medical-devices": {
    "title": "Medical Writing for Medical Devices — Clinical Solutions | QbD Group",
    "description": "High-quality medical writing is crucial for regulatory compliance and patient safety. Our team offers complete medical writing services that bridge the gap",
    "ogImage": "/og-assets/services/clinical-solutions/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/zh-cn/services/clinical-solutions/pmcf": {
    "title": "Post-Market Clinical Follow-up (PMCF) — Clinical Solutions | QbD Group",
    "description": "We help you navigate the complexities of PMCF with tailored, efficient, and MDR-compliant strategies that turn regulatory obligations into clinical and com",
    "ogImage": "/og-assets/services/clinical-solutions/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/zh-cn/services/clinical-solutions/pmpf": {
    "title": "Post-Market Performance Follow-up (PMPF) — Clinical Solutions | QbD Group",
    "description": "At QbD IVD | Qarad, we help you turn PMPF into a practical, structured process—supporting your regulatory compliance and safeguarding patient outcomes.",
    "ogImage": "/og-assets/services/clinical-solutions/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/zh-cn/services/lab-services/chemical-analysis": {
    "title": "QC 化学分析 — Lab Services | QbD Group",
    "description": "QbD Group 经 GMP 认证的 QC 实验室,为原料、API、IMP 以及成品药提供可靠、精准的化学分析服务。",
    "ogImage": "/og-assets/services/lab-services/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/zh-cn/services/lab-services/cleaning-validation": {
    "title": "清洁验证 — Lab Services | QbD Group",
    "description": "QbD Group 帮助您定义并实施清洁验证的最佳实践，确保符合行业标准与法规要求。",
    "ogImage": "/og-assets/services/lab-services/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/zh-cn/services/lab-services/elemental-impurities": {
    "title": "元素杂质 — Lab Services | QbD Group",
    "description": "QbD Group 提供专业支持，按照 ICH Q3D 指南分析、控制并降低元素杂质风险。",
    "ogImage": "/og-assets/services/lab-services/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/zh-cn/services/lab-services/environmental-monitoring": {
    "title": "环境监测 — Lab Services | QbD Group",
    "description": "QbD Group 专注于环境监测，帮助您维持洁净室合规性，确保生产过程的完整性。",
    "ogImage": "/og-assets/services/lab-services/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/zh-cn/services/lab-services/method-development": {
    "title": "方法开发 — Lab Services | QbD Group",
    "description": "QbD Group 将深厚的科学专业知识与创新方法相结合，为您量身定制稳健的分析方法。",
    "ogImage": "/og-assets/services/lab-services/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/zh-cn/services/lab-services/method-validation": {
    "title": "方法验证 — Lab Services | QbD Group",
    "description": "QbD Group 确保您的分析方法符合 ICH Q2(R1) 及药典指南等全球标准,提供准确且可重复的结果。",
    "ogImage": "/og-assets/services/lab-services/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/zh-cn/services/lab-services/microbiological-analysis": {
    "title": "微生物检测服务 — Lab Services | QbD Group",
    "description": "QbD Group 提供专业的微生物检测与验证服务，确保您的原料和成品的纯度与安全性。",
    "ogImage": "/og-assets/services/lab-services/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/zh-cn/services/lab-services/qp-release-and-eu-import": {
    "title": "QP 批次放行 — Lab Services | QbD Group",
    "description": "QbD Group 提供全面的 QP 批次放行服务，确保您的药品符合严格的 EU 法规标准。",
    "ogImage": "/og-assets/services/lab-services/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/zh-cn/services/lab-services/rd-projects": {
    "title": "R&D Projects — Lab Services | QbD Group",
    "description": "QbD Group leverages deep scientific expertise and cutting-edge technologies to support pharmaceutical R&D projects with tailored solutions.",
    "ogImage": "/og-assets/services/lab-services/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/zh-cn/services/lab-services/residual-solvent-testing-gc": {
    "title": "Residual Solvent Testing (GC) — Lab Services | QbD Group",
    "description": "Residual solvent testing identifies and quantifies trace organic solvents after manufacturing using validated GC-FID and GC-MS methods, ensuring compliance",
    "ogImage": "/og-assets/services/lab-services/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/zh-cn/services/lab-services/stability-studies": {
    "title": "Stability Studies — Lab Services | QbD Group",
    "description": "QbD Group ensures your products meet the highest quality standards through rigorous ICH-compliant stability studies with state-of-the-art facilities.",
    "ogImage": "/og-assets/services/lab-services/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/zh-cn/services/pharmacovigilance/aggregate-safety-reporting": {
    "title": "安全性报告与信号检测 — Pharmacovigilance | QbD Group",
    "description": "安全性报告是 Pharmacovigilance 和上市后监测的关键组成部分。在 QbD Group，我们分析并交付符合全球法规要求的安全性报告。",
    "ogImage": "/og-assets/services/pharmacovigilance/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/zh-cn/services/pharmacovigilance/comprehensive-medical-information-services": {
    "title": "全面医学信息服务 — Pharmacovigilance | QbD Group",
    "description": "准确且及时的医学信息不仅是法规要求 — 更是患者安全与产品信赖的重要组成部分。通过我们的医学信息服务，我们确保与您的相关方进行清晰、准确的沟通。",
    "ogImage": "/og-assets/services/pharmacovigilance/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/zh-cn/services/pharmacovigilance/eudravigilance-services": {
    "title": "EudraVigilance Medicinal Product Dictionary (XEVMPD) — Pharmacovigilance | QbD Group",
    "description": "Achieve XEVMPD compliance effortlessly with QbD's expertise. Simplify your regulatory submissions and maintain up-to-date safety profiles with comprehensiv",
    "ogImage": "/og-assets/services/pharmacovigilance/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/zh-cn/services/pharmacovigilance/icsr-management": {
    "title": "ICSR 管理 — Pharmacovigilance | QbD Group",
    "description": "有效管理安全病例报告是 Pharmacovigilance 与临床试验监督的基石。在 QbD Group，我们的专业 ICSR 管理服务可确保安全信息的及时收集、处理与上报。",
    "ogImage": "/og-assets/services/pharmacovigilance/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/zh-cn/services/pharmacovigilance/literature-monitoring": {
    "title": "Literature Monitoring Search Solutions & Alerts — Pharmacovigilance | QbD Group",
    "description": "Stay compliant with QbD Group's Literature Monitoring Services. Detect safety signals, ensure timely reporting, and enhance your vigilance strategy with sy",
    "ogImage": "/og-assets/services/pharmacovigilance/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/zh-cn/services/pharmacovigilance/pharmacovigilance-certified-blended-training": {
    "title": "Pharmacovigilance 与认证混合式培训 — Pharmacovigilance | QbD Group",
    "description": "在快速演变的 Pharmacovigilance 领域，确保团队接受良好培训并遵守国家和国际法规至关重要。我们提供量身定制的课程和在线培训平台，旨在提升合规标准。",
    "ogImage": "/og-assets/services/pharmacovigilance/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/zh-cn/services/pharmacovigilance/project-management": {
    "title": "Project Management — Pharmacovigilance | QbD Group",
    "description": "Coordinate pharmacovigilance projects seamlessly with QbD's project management expertise. Drive safety goals, meet compliance requirements, and improve ope",
    "ogImage": "/og-assets/services/pharmacovigilance/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/zh-cn/services/pharmacovigilance/pv-audits-inspections-quality-system-management": {
    "title": "Pharmacovigilance（PV）审计 — Pharmacovigilance | QbD Group",
    "description": "在 QbD Group，我们提供经过认证的 PV 审计、模拟检查以及与 ISO 相关的活动，以确保您的 Pharmacovigilance 体系符合 Good Pharmacovigilance Practices（GPvP）和国际质量标准。",
    "ogImage": "/og-assets/services/pharmacovigilance/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/zh-cn/services/pharmacovigilance/qms-psmf-services": {
    "title": "Pharmacovigilance QMS 与 PSMF 服务 — Pharmacovigilance | QbD Group",
    "description": "满足国家与国际 Pharmacovigilance 法规要求需要稳健的体系和细致的文档记录。在 QbD Group，我们提供全面的 Pharmacovigilance QMS 以及 PSMF 支持。",
    "ogImage": "/og-assets/services/pharmacovigilance/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/zh-cn/services/pharmacovigilance/qppv-local-representative": {
    "title": "本地 QPPV 代表服务 — Pharmacovigilance | QbD Group",
    "description": "在多个地区管理 Pharmacovigilance 职责可能颇为复杂。在 QbD Vigilance，我们提供量身定制的 QPPV 与本地代表服务，以满足欧洲、英国及其他地区 MAH 的特定法规需求。",
    "ogImage": "/og-assets/services/pharmacovigilance/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/zh-cn/services/pharmacovigilance/regulatory-intelligence": {
    "title": "法规情报 — Pharmacovigilance | QbD Group",
    "description": "在当今快速演变的法规环境中，遵守国际与本地法规至关重要。在 QbD Group，我们的法规情报服务为您提供应对复杂要求所需的工具与专业能力。",
    "ogImage": "/og-assets/services/pharmacovigilance/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/zh-cn/services/pharmacovigilance/safety-database-solution": {
    "title": "Tracking Adverse Drug Reactions — Pharmacovigilance | QbD Group",
    "description": "Monitor and address adverse drug reactions with precision. QbD Group's safety database solutions support regulatory compliance while prioritizing operation",
    "ogImage": "/og-assets/services/pharmacovigilance/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/zh-cn/services/pharmacovigilance/signal-detection-management": {
    "title": "Safety Signal Program — Pharmacovigilance | QbD Group",
    "description": "Enhance patient safety with QbD Group's Safety Signal Program. Detect risks early, ensure compliance, and build trust with proactive safety solutions throu",
    "ogImage": "/og-assets/services/pharmacovigilance/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/zh-cn/services/pharmacovigilance/vigilance-pharmacovigilance-hotline-services": {
    "title": "Vigilance and Pharmacovigilance Hotline Services — Pharmacovigilance | QbD Group",
    "description": "Emergencies don't sleep and neither does our support. The One Vigilance hotline is open 24/7 all year round, providing dedicated pharmacovigilance support",
    "ogImage": "/og-assets/services/pharmacovigilance/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/zh-cn/services/qualification-validation/analytical-method-validation": {
    "title": "分析方法验证 — Qualification & Validation | QbD Group",
    "description": "通过我们全面的分析方法验证服务，确保您的药品产品达到最高的法规标准。我们专注于提供精准、可靠且合规的解决方案，帮助您验证对质量控制至关重要的分析方法。",
    "ogImage": "/og-assets/services/qualification-validation/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/zh-cn/services/qualification-validation/cleaning-validation": {
    "title": "清洁验证 — Qualification & Validation | QbD Group",
    "description": "QbD 为您的流程、应用和设备提供广泛的确认与验证服务。我们的专家在清洁验证方面拥有深厚的专业知识，确保您的运营符合最高标准。",
    "ogImage": "/og-assets/services/qualification-validation/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/zh-cn/services/qualification-validation/commissioning": {
    "title": "Commissioning — Qualification & Validation | QbD Group",
    "description": "Commissioning 对于让您的系统和设备在各行各业中实现最佳性能并保持安全至关重要。在 QbD Group，我们是确保您的系统、utilities、设施和设备正常运行的专家。",
    "ogImage": "/og-assets/services/qualification-validation/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/zh-cn/services/qualification-validation/equipment-qualification": {
    "title": "设备确认 — Qualification & Validation | QbD Group",
    "description": "您是否在为项目中的 C&Q 与设备确认部分寻找交钥匙解决方案？无论您是在新建还是改造，并需要对设备进行确认，我们都能为您提供帮助！从简单设备到更复杂的系统，QbD Group 提供灵活且量身定制的解决方案，满足您的需求。",
    "ogImage": "/og-assets/services/qualification-validation/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/zh-cn/services/qualification-validation/facility-qualification": {
    "title": "设施确认 — Qualification & Validation | QbD Group",
    "description": "在 QbD Group，我们提供根据您所在行业及具体法规要求量身定制的设施确认服务。与我们合作，您可以确信您的设施和 utilities 已按最高标准完成验证，从而保障运营的可靠性、效率与安全。",
    "ogImage": "/og-assets/services/qualification-validation/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/zh-cn/services/qualification-validation/process-product-support": {
    "title": "工艺与产品支持 — Qualification & Validation | QbD Group",
    "description": "我们经验丰富的团队在工艺优化、质量管理、法规合规以及持续改进方法方面拥有专业知识，帮助您实现卓越的运营与产品表现。",
    "ogImage": "/og-assets/services/qualification-validation/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/zh-cn/services/qualification-validation/process-validation": {
    "title": "工艺验证 — Qualification & Validation | QbD Group",
    "description": "您是否在寻找工艺验证方面的专业能力？工艺验证是维护产品质量、法规合规与生产卓越运营的关键环节。与 QbD Group 合作，您可以确信您的工艺已按最高标准完成验证。",
    "ogImage": "/og-assets/services/qualification-validation/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/zh-cn/services/qualification-validation/sterilization-validation": {
    "title": "灭菌验证 — Qualification & Validation | QbD Group",
    "description": "我们专注于提供根据您所在行业及具体法规要求量身定制的全面灭菌验证服务。灭菌验证是确保产品安全、法规合规与消费者信任的关键环节。",
    "ogImage": "/og-assets/services/qualification-validation/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/zh-cn/services/qualification-validation/tech-transfer": {
    "title": "技术转移 — Qualification & Validation | QbD Group",
    "description": "技术转移是将创新转化为实际应用、推动经济增长、促进协作与创新的关键环节。我们经验丰富的 QbD Group 团队提供全面的支持，涵盖从技术评估与文档管理到工艺优化与培训的各个方面。",
    "ogImage": "/og-assets/services/qualification-validation/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/zh-cn/services/qualification-validation/utility-qualification": {
    "title": "Utility 确认 — Qualification & Validation | QbD Group",
    "description": "在 QbD Group，我们提供根据您所在行业及具体法规要求量身定制的 utility 确认服务。与 QbD Group 合作，确保您的 utilities 按最高标准完成验证，保障运营的可靠性、效率与安全。",
    "ogImage": "/og-assets/services/qualification-validation/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/zh-cn/services/quality-assurance/qa-consultancy-apr-pqr": {
    "title": "Annual Product Review (APR) & Product Quality Review (PQR) — Quality Assurance | QbD Group",
    "description": "QbD Group offers full support for Annual Product Review and Product Quality Review — from data analysis and PQR writing to compliance review. These mandato",
    "ogImage": "/og-assets/services/quality-assurance/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/zh-cn/services/quality-assurance/integrated-audit-solutions": {
    "title": "QA 审计与整改 — Quality Assurance | QbD Group",
    "description": "QbD Group 提供经认证且经验丰富的审计师,代表您执行内部审计与供应商审计。我们的 QA 专家还可协助您有效解决审计发现,确保合规并推动持续改进。",
    "ogImage": "/og-assets/services/quality-assurance/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/zh-cn/services/quality-assurance/qa-support-outsourcing": {
    "title": "QA 外包 — Quality Assurance | QbD Group",
    "description": "QbD Group 由专属专家团队接管您的质量保证活动。从供应商管理到偏差处理,我们提供无缝、高性价比的解决方案,让您专注于核心战略。",
    "ogImage": "/og-assets/services/quality-assurance/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/zh-cn/services/quality-assurance/qms-remediation-support": {
    "title": "QMS 整改与支持 — Quality Assurance | QbD Group",
    "description": "QbD Group 提供经验丰富的 QA 专家,帮助您管理和升级质量管理体系,确保持续合规与卓越运营。从差距整改到日常 QMS 支持,我们根据您的需求量身定制服务。",
    "ogImage": "/og-assets/services/quality-assurance/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/zh-cn/services/quality-assurance/qms-development-optimization": {
    "title": "质量管理体系搭建 — Quality Assurance | QbD Group",
    "description": "QbD Group 拥有经验丰富的 QA 专家,擅长为您打造智能、高效且合规的 QMS 解决方案。无论您聚焦于 GMP、GCP、GDP 还是 ISO 标准,我们都将确保您的体系既能为业务赋能,又能满足法规要求。",
    "ogImage": "/og-assets/services/quality-assurance/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/zh-cn/services/quality-assurance/qp-rp-prrc-services": {
    "title": "合格人员 (QP) 与负责人 (RP) 服务 — Quality Assurance | QbD Group",
    "description": "QbD Group 提供经验丰富的合格人员 (QP) 与负责人 (RP),帮助您满足强制性要求、保持合规并确保运营连续性。从批次放行到合规监控,我们的专家全方位支持您的需求。",
    "ogImage": "/og-assets/services/quality-assurance/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/zh-cn/services/regulatory-affairs/artwork-labeling": {
    "title": "包装与标签 — Regulatory Affairs | QbD Group",
    "description": "欧盟指令 2001/83/CE 要求标签文本必须与经批准的产品特性概要 (SmPC) 一致。QbD Group 帮助您创建完全合规的药品包装图稿。",
    "ogImage": "/og-assets/services/regulatory-affairs/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/zh-cn/services/regulatory-affairs/authorized-representative-eu-rep": {
    "title": "欧盟授权代表 (EU-REP) — Regulatory Affairs | QbD Group",
    "description": "如果您是欧盟/欧洲经济区以外的医疗器械或 IVD 制造商，根据法律要求，您必须指定一名欧盟授权代表，以确保符合 MDR 和 IVDR 的规定。",
    "ogImage": "/og-assets/services/regulatory-affairs/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/zh-cn/services/regulatory-affairs/coaching-training": {
    "title": "法规指导与培训 — Regulatory Affairs | QbD Group",
    "description": "QbD Group 提供定制化培训项目，旨在加强您的团队对 MDR/IVDR 的理解和实际法规应用能力。",
    "ogImage": "/images/offerings/coaching-training-ra.jpg",
    "ogImageWidth": 1408,
    "ogImageHeight": 768
  },
  "/zh-cn/services/regulatory-affairs/combination-products": {
    "title": "Regulatory Affairs Services | QbD Group",
    "description": "Get your product to market with confidence through expert Regulatory Affairs support. From strategy to product approval, we offer tailored services to navi",
    "ogImage": "/og-assets/services/regulatory-affairs/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/zh-cn/services/regulatory-affairs/design-and-development": {
    "title": "设计与开发 — Regulatory Affairs | QbD Group",
    "description": "设计与开发是将安全有效的医疗器械和 IVD 推向市场的核心环节。我们的团队在整个设计周期内提供专业指导。",
    "ogImage": "/og-assets/services/regulatory-affairs/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/zh-cn/services/regulatory-affairs/drug-development": {
    "title": "药品开发 — Regulatory Affairs | QbD Group",
    "description": "药品开发包括发现、临床前和临床测试。新化学实体在上市前必须证明其符合安全性、毒性、药代动力学和新陈代谢的最低标准。",
    "ogImage": "/og-assets/services/regulatory-affairs/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/zh-cn/services/regulatory-affairs/early-development": {
    "title": "早期开发 — Regulatory Affairs | QbD Group",
    "description": "潜在药物早期开发的一个关键步骤是为首次人体研究准备临床试验申请。",
    "ogImage": "/og-assets/services/regulatory-affairs/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/zh-cn/services/regulatory-affairs/ectd-publishing": {
    "title": "eCTD 发布 — Regulatory Affairs | QbD Group",
    "description": "eCTD 基于 CTD 格式，以电子形式将行业法规信息传输给监管机构。",
    "ogImage": "/og-assets/services/regulatory-affairs/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/zh-cn/services/regulatory-affairs/in-country-representative-services": {
    "title": "境内代表服务 — Regulatory Affairs | QbD Group",
    "description": "我们的法规专家可担任 EU-REP/UKRP/CH-REP，帮助您的 IVD 和医疗器械进入欧洲、英国和瑞士市场。",
    "ogImage": "/og-assets/services/regulatory-affairs/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/zh-cn/services/regulatory-affairs/information-officer": {
    "title": "信息负责人 — Regulatory Affairs | QbD Group",
    "description": "为完全符合法律要求，必须由合格的专家负责药品信息的沟通和营销方式。",
    "ogImage": "/og-assets/services/regulatory-affairs/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/zh-cn/services/regulatory-affairs/ivdr-compliance-ce-certification": {
    "title": "IVDR Compliance & CE Certification — Regulatory Affairs | QbD Group",
    "description": "The EU In Vitro Diagnostic Regulation (EU) 2017/746 has fundamentally changed how in vitro diagnostics access the European market. QbD Group supports manuf",
    "ogImage": "/images/offerings/ivdr-compliance-ce-certification-ra.jpg",
    "ogImageWidth": 1408,
    "ogImageHeight": 768
  },
  "/zh-cn/services/regulatory-affairs/ivdr-transition-support": {
    "title": "IVDD 到 IVDR 的过渡支持 — Regulatory Affairs | QbD Group",
    "description": "平均认证周期为 13 至 18 个月，且过渡截止日期日益临近，IVD 制造商不能再有任何拖延。提前规划不仅能确保合规性，还能为您带来竞争优势。",
    "ogImage": "/og-assets/services/regulatory-affairs/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/zh-cn/services/regulatory-affairs/legal-representative": {
    "title": "法定代表人 — Regulatory Affairs | QbD Group",
    "description": "对于总部设在欧盟以外的性能研究申办方来说，在欧盟境内指定一名法定代表人是一项法规要求。QbD Group 可提供专业的欧盟代表服务。",
    "ogImage": "/og-assets/services/regulatory-affairs/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/zh-cn/services/regulatory-affairs/liaison-with-notified-bodies": {
    "title": "与公告机构联络 — Regulatory Affairs | QbD Group",
    "description": "与公告机构互动是医疗器械和 IVD 合格评定流程中的一个关键步骤。QbD Group 在每个阶段为制造商提供支持，帮助确保沟通结构化、清晰，并与战略保持一致。",
    "ogImage": "/images/offerings/liaison-notified-bodies-ra.jpg",
    "ogImageWidth": 1408,
    "ogImageHeight": 768
  },
  "/zh-cn/services/regulatory-affairs/lifecycle-management": {
    "title": "生命周期管理 — Regulatory Affairs | QbD Group",
    "description": "已上市的产品会随着时间的推移而发生变化，这一过程必须得到妥善管理。QbD Group 的专家将在整个生命周期管理过程中为您提供支持。",
    "ogImage": "/og-assets/services/regulatory-affairs/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/zh-cn/services/regulatory-affairs/linguistic-review": {
    "title": "语言审核 — Regulatory Affairs | QbD Group",
    "description": "语言审核过程中的最大挑战之一是翻译的交付周期极短。QbD Group 确保提供高质量的翻译，并满足程序性截止日期。",
    "ogImage": "/og-assets/services/regulatory-affairs/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/zh-cn/services/regulatory-affairs/materiovigilance": {
    "title": "警戒 — Regulatory Affairs | QbD Group",
    "description": "警戒是指对上市后的医疗器械和 IVD 相关事件进行系统性的监测、评估和报告。QbD Group 协助制造商实施合规且高效的警戒系统。",
    "ogImage": "/images/offerings/materiovigilance-ra.jpg",
    "ogImageWidth": 1408,
    "ogImageHeight": 768
  },
  "/zh-cn/services/regulatory-affairs/mdr-compliance-ce-certification-for-medical-devices": {
    "title": "MDR 合规与 CE 认证 — Regulatory Affairs | QbD Group",
    "description": "欧盟医疗器械法规为安全性、质量和透明度设立了更高标准。无论您是计划将新器械推向市场，还是对现有器械进行过渡，我们都将全程为您提供指导。",
    "ogImage": "/og-assets/services/regulatory-affairs/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/zh-cn/services/regulatory-affairs/mdr-transition-support": {
    "title": "MDD 到 MDR 的过渡支持 — Regulatory Affairs | QbD Group",
    "description": "从 MDD 到 MDR 的转变是医疗器械行业几十年来面临的最重大的法规变革之一。QbD Group 帮助您顺利完成这一过渡。",
    "ogImage": "/og-assets/services/regulatory-affairs/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/zh-cn/services/regulatory-affairs/notified-body-submissions": {
    "title": "向公告机构提交资料 — Regulatory Affairs | QbD Group",
    "description": "对于医疗器械和 IVD 而言，向公告机构提交资料是获得 CE 标志的关键一步。我们能根据您的具体要求提供全面的支持。",
    "ogImage": "/og-assets/services/regulatory-affairs/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/zh-cn/services/regulatory-affairs/orphan-diseases": {
    "title": "罕见病 — Regulatory Affairs | QbD Group",
    "description": "孤儿病是影响少数人群的疾病。QbD Group 可支持您为罕见病患者开发药物。",
    "ogImage": "/og-assets/services/regulatory-affairs/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/zh-cn/services/regulatory-affairs/person-responsible-for-regulatory-compliance": {
    "title": "法规合规负责人 (PRRC) — Regulatory Affairs | QbD Group",
    "description": "为了在欧盟市场销售产品，医疗器械和 IVD 制造商必须正式指定一名 PRRC。如果没有正式指定的 PRRC，公司将无法在欧盟销售其产品。",
    "ogImage": "/og-assets/services/regulatory-affairs/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/zh-cn/services/regulatory-affairs/post-market-surveillance": {
    "title": "上市后监督 — Regulatory Affairs | QbD Group",
    "description": "上市后监督是一项基本要求，旨在确保您的 IVD 或医疗器械投放市场后能够持续保障其安全性和有效性。",
    "ogImage": "/og-assets/services/regulatory-affairs/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/zh-cn/services/regulatory-affairs/regulatory-intelligence": {
    "title": "法规情报 — Regulatory Affairs | QbD Group",
    "description": "法规情报对于成功的产品开发和有效的法规策略至关重要。利用最新、最全面的信息，您可以在竞争中保持领先。",
    "ogImage": "/og-assets/services/regulatory-affairs/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/zh-cn/services/regulatory-affairs/regulatory-procedures": {
    "title": "监管程序 — Regulatory Affairs | QbD Group",
    "description": "在欧盟和英国，有多种药品注册程序可供选择。选择哪种方法取决于药品类型和预期的上市途径。",
    "ogImage": "/og-assets/services/regulatory-affairs/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/zh-cn/services/regulatory-affairs/regulatory-strategy-md-ivd": {
    "title": "医疗器械和IVD的法规策略 — Regulatory Affairs | QbD Group",
    "description": "法规策略是一个重要框架，它概述了将医疗器械或IVD推向市场所需遵循的法规要求的必要步骤和行动。",
    "ogImage": "/og-assets/services/regulatory-affairs/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/zh-cn/services/regulatory-affairs/regulatory-strategy-pharma": {
    "title": "制药监管策略 — Regulatory Affairs | QbD Group",
    "description": "制定监管策略涉及为特定产品类型选择合适的程序、分析当地法规与要求、选择上市国家，并为产品上市时间提供建议。",
    "ogImage": "/og-assets/services/regulatory-affairs/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/zh-cn/services/regulatory-affairs/scientific-advice": {
    "title": "科学建议 — Regulatory Affairs | QbD Group",
    "description": "科学建议程序在药品审批流程中起着核心作用。我们经验丰富的顾问将帮助您与所有相关的卫生监管机构进行互动。",
    "ogImage": "/og-assets/services/regulatory-affairs/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/zh-cn/services/regulatory-affairs/submissions": {
    "title": "监管递交 — Regulatory Affairs | QbD Group",
    "description": "在复杂的监管环境中申请上市许可，需要满足严格的文件和合规要求。我们确保您的申请符合所有监管标准。",
    "ogImage": "/og-assets/services/regulatory-affairs/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/zh-cn/services/regulatory-affairs/swiss-authorized-representative": {
    "title": "瑞士授权代表 (CH-REP) — Regulatory Affairs | QbD Group",
    "description": "总部位于瑞士境外的制造商必须指定一名瑞士授权代表，方可在瑞士市场销售医疗器械和 IVD 产品。",
    "ogImage": "/og-assets/services/regulatory-affairs/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/zh-cn/services/regulatory-affairs/technical-documentation": {
    "title": "技术文档 — Regulatory Affairs | QbD Group",
    "description": "针对 IVD 和医疗器械的新法规对技术文档和临床证据提出了更严格的要求。我们拥有二十多年的经验，可提供无与伦比的专业支持。",
    "ogImage": "/og-assets/services/regulatory-affairs/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/zh-cn/services/regulatory-affairs/ukrp-uk-responsible-person": {
    "title": "英国负责人 (UKRP) — Regulatory Affairs | QbD Group",
    "description": "英国脱欧后，位于英国境外的制造商必须指定一名英国负责人，才能在大不列颠市场销售医疗器械和 IVD。",
    "ogImage": "/og-assets/services/regulatory-affairs/hero.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/zh-cn/services/regulatory-toxicology": {
    "title": "法规毒理学 | QbD Group",
    "description": "从 PDE/ADE 报告到亚硝胺风险评估和 REACH 注册,我们的 EUROTOX 认证毒理学家团队提供科学严谨且符合法规的报告。",
    "ogImage": "/og-assets/hubs/services-toxicology.jpg",
    "ogImageWidth": 1200,
    "ogImageHeight": 630
  },
  "/zh-cn/services/regulatory-toxicology/elemental-impurities-reports": {
    "title": "元素杂质报告 — 法规毒理学 | QbD Group",
    "description": "QbD Group 为人用和兽用药品中的元素杂质提供全面的风险评估和报告，确保符合 ICH Q3D 指南和法规要求。"
  },
  "/zh-cn/services/regulatory-toxicology/environmental-risk-assessment-era": {
    "title": "环境风险评估 (ERA) — 法规毒理学 | QbD Group",
    "description": "QbD Group 在 ERA 全生命周期为制药企业提供支持，将科学专业知识与务实、基于风险的方法相结合，交付可直接用于上市许可申请的申报文件。"
  },
  "/zh-cn/services/regulatory-toxicology/extractables-leachables-reports": {
    "title": "可提取物与浸出物报告 — 法规毒理学 | QbD Group",
    "description": "QbD Group 为可提取物和浸出物杂质提供毒理学和风险评估，量身定制以满足您的特定需求，并确保符合 FDA、EMA 和 ICH 标准。"
  },
  "/zh-cn/services/regulatory-toxicology/monitoring-studies": {
    "title": "监测研究 — 法规毒理学 | QbD Group",
    "description": "QbD Group 为药品生产和质量所需的实验室研究跟踪提供专业支持，包括方法验证、结果审核以及用于法规申报的报告撰写。"
  },
  "/zh-cn/services/regulatory-toxicology/nitrosamine-risk-assessment": {
    "title": "亚硝胺风险评估 — 法规毒理学 | QbD Group",
    "description": "QbD Group 专注于亚硝胺风险评估，帮助制药企业识别风险、撰写报告、计算可接受限度，并回应监管机构的要求。"
  },
  "/zh-cn/services/regulatory-toxicology/organic-impurities-reports": {
    "title": "有机杂质报告 — 法规毒理学 | QbD Group",
    "description": "QbD Group 提供由 AETOX 成员认证的高质量毒理学报告在线库，涵盖药品制造中有机杂质的风险评估和毒理学评估。"
  },
  "/zh-cn/services/regulatory-toxicology/pde-oel-reports": {
    "title": "PDE-OEL 报告 — 法规毒理学 | QbD Group",
    "description": "QbD Group 依据 EMA 指南为任何活性药物成分编制 PDE/ADE 报告。我们的 ERT 认证毒理学家为制药和兽药行业提供科学严谨的评估。"
  },
  "/zh-cn/services/regulatory-toxicology/reach-registration-compliance-support": {
    "title": "REACH 注册与合规支持 — 法规毒理学 | QbD Group",
    "description": "QbD Group 协助您完成 REACH 注册的每一步，从物质表征、IUCLID 卷宗编制，到安全数据表(SDS)起草和化学品安全报告(CSR)撰写。"
  },
  "/zh-cn/services/regulatory-toxicology/residual-solvents-reports": {
    "title": "残留溶剂报告 — 法规毒理学 | QbD Group",
    "description": "QbD Group 专注于人用和兽用药品中残留溶剂的风险评估，帮助识别风险、生成全面报告，并依据 ICH Q3C 指南应对法规关切。"
  },
  "/zh-cn/services/software-solutions-services/ai-ml-compliance": {
    "title": "AI/ML 合规 — Software Solutions & Services | QbD Group",
    "description": "在 AI 与机器学习快速发展的背景下，开发符合法规标准的软件解决方案至关重要。QbD Group 提供全面的 AI/ML 合规支持，助您缩短上市路径。",
    "ogImage": "/og-assets/services/software-solutions-services/ai-ml-compliance.jpg",
    "ogImageWidth": 1344,
    "ogImageHeight": 768
  },
  "/zh-cn/services/software-solutions-services/data-governance": {
    "title": "数据治理 — Software Solutions & Services | QbD Group",
    "description": "您是否担心难以跟上复杂且不断变化的法规要求？QbD Group 提供数据治理支持，帮助您符合最新标准与法规，并缩短上市路径。",
    "ogImage": "/og-assets/services/software-solutions-services/data-governance.jpg",
    "ogImageWidth": 1344,
    "ogImageHeight": 768
  },
  "/zh-cn/services/software-solutions-services/data-integrity": {
    "title": "数据完整性 — Software Solutions & Services | QbD Group",
    "description": "从设备与实验室系统到自动化系统与 IT 基础设施，数据完整性一如既往地至关重要。QbD Group 提供定制化专业能力，帮助贵公司符合最新法规要求。",
    "ogImage": "/og-assets/services/software-solutions-services/data-integrity.jpg",
    "ogImageWidth": 1344,
    "ogImageHeight": 768
  },
  "/zh-cn/services/software-solutions-services/digitalization": {
    "title": "生命科学领域的数字化 — Software Solutions & Services | QbD Group",
    "description": "QbD Group 帮助 Life Sciences 企业实现运营现代化与精简。我们量身定制的数字化解决方案确保平稳过渡到更高效、更敏捷且更合规的流程，同时保障数据完整性与长期增长。",
    "ogImage": "/og-assets/services/software-solutions-services/digitalization-what.png",
    "ogImageWidth": 1200,
    "ogImageHeight": 675
  },
  "/zh-cn/services/software-solutions-services/ifucare": {
    "title": "IFUcare — 电子 IFU 解决方案 — Software Solutions & Services | QbD Group",
    "description": "IFUcare 为医疗器械和 IVD 制造商提供无缝的电子 IFU 服务，帮助您告别纸质 IFU，转向合规且经济高效的电子标签。",
    "ogImage": "/og-assets/services/software-solutions-services/ifucare-mockup.jpg",
    "ogImageWidth": 1000,
    "ogImageHeight": 600
  },
  "/zh-cn/services/software-solutions-services/it-infrastructure-qualification": {
    "title": "IT 基础设施确认 — Software Solutions & Services | QbD Group",
    "description": "在当今高度受监管的环境中，确保 IT 基础设施的可靠性与合规性是一项日益严峻的挑战。QbD Group 提供 IT 基础设施确认专业能力，帮助贵公司符合最新法规要求。",
    "ogImage": "/og-assets/services/software-solutions-services/it-infrastructure-qualification.jpg",
    "ogImageWidth": 1344,
    "ogImageHeight": 768
  },
  "/zh-cn/services/software-solutions-services/medical-device-software-compliance": {
    "title": "医疗器械软件合规 — Software Solutions & Services | QbD Group",
    "description": "我们的医疗器械软件合规服务帮助 Medical Devices 与 In Vitro Diagnostics 企业确保其软件符合 MDR、IVDR、FDA、ISO 13485、ISO 14971、IEC 62304 和 IEC 82304。借助量身定制的框架和专家指导，我们让合规变得更简单。",
    "ogImage": "/og-assets/services/software-solutions-services/medical-device-software-compliance.png",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/zh-cn/services/software-solutions-services/operational-software-compliance": {
    "title": "Operational Software Compliance — Software Solutions & Services | QbD Group",
    "description": "Maintaining compliance with regulatory standards is no small task. QbD Group's operational software compliance services ensure your software systems meet i",
    "ogImage": "/og-assets/services/software-solutions-services/operational-software-compliance.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/zh-cn/services/software-solutions-services/paperless-validation": {
    "title": "Paperless Validation — Software Solutions & Services | QbD Group",
    "description": "Paperless validation offers a digital approach that revolutionizes the validation process in regulated industries. Say goodbye to paper-based documentation",
    "ogImage": "/og-assets/services/software-solutions-services/paperless-validation.jpg",
    "ogImageWidth": 1344,
    "ogImageHeight": 768
  },
  "/zh-cn/services/software-solutions-services/scilife": {
    "title": "Scilife™ — 质量管理软件 — Software Solutions & Services | QbD Group",
    "description": "Scilife™ 是一款用户友好的一体化质量管理软件，旨在简化工作流程的方方面面——从文档管理、培训，到 CAPA 与 AI 驱动的 KPI。",
    "ogImage": "/og-assets/services/software-solutions-services/scilife-mockup.png",
    "ogImageWidth": 1280,
    "ogImageHeight": 720
  },
  "/zh-cn/services/software-solutions-services/software-implementations": {
    "title": "Software Implementations — Software Solutions & Services | QbD Group",
    "description": "Software implementations are essential for modern life science organizations to stay competitive. Our team of software experts ensures that your implementa",
    "ogImage": "/og-assets/services/software-solutions-services/software-implementations.png",
    "ogImageWidth": 600,
    "ogImageHeight": 400
  },
  "/zh-cn/services/software-solutions-services/software-validation": {
    "title": "软件与中央 IT 系统验证 — Software Solutions & Services | QbD Group",
    "description": "从自动化、数字化到人工智能与机器学习，软件验证依然至关重要。QbD Group 提供软件验证与 CSV 专业能力，帮助贵公司符合最新法规要求。",
    "ogImage": "/og-assets/services/software-solutions-services/software-validation.jpg",
    "ogImageWidth": 1600,
    "ogImageHeight": 900
  },
  "/zh-cn/solutions": {
    "title": "生命科学解决方案 | QbD Group",
    "description": "为制药、生物技术、医疗器械和 IVD 提供法规、质量和市场准入解决方案，从创意到市场就绪。"
  },
  "/zh-cn/supplier-code-of-conduct": {
    "title": "供应商行为准则 | QbD Group",
    "description": "QbD Group 的供应商行为准则——我们对道德、可持续和负责任商业实践的期望。",
    "noIndex": true
  },
  "/zh-cn/thank-you/contact": {
    "title": "我们已收到您的消息！ | QbD Group",
    "description": "感谢您的联系",
    "noIndex": true
  },
  "/zh-cn/webinars": {
    "title": "生命科学网络研讨会 | QbD Group",
    "description": "观看由专家主讲的网络研讨会,涵盖法规事务、质量保证、临床策略等,覆盖制药、生物技术和医疗器械领域。",
    "ogImage": "/og-assets/webinar-hero-bg.jpg",
    "ogImageWidth": 1920,
    "ogImageHeight": 1088
  }
};
